/* eslint-disable no-case-declarations */
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="grid-view">
    <div v-show="currentOptStatus!==optStatusDefs.billDetailView && currentOptStatus!==optStatusDefs.newBillDetailView" class="main-content">
      <search-item
        v-show="billType==='charge'"
        ref="searchItem1"
        key="1"
        :is-append-query="true"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        :search-item-code="$t('Clearing.ReconciliationByFee')"
        config-module="5031"
        grid-config-module="190901"
        :auto-init="false"
        :custom-search-items="chargeCustomSearchItems"
        :custom-sim-query-placeholder="$t('Clearing.QuickSearchBusinessNumber')"
        :disabled="currentOptStatus===optStatusDefs.checking"
        @query="fetchData"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{chargePerConfigName=value}"
        @refreshGrid="()=>{chargeGridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{chargeDefaultSearchItems=value}"
      >
        <template slot="operations">
          <div v-if="currentOptStatus===optStatusDefs.normal">
            <el-button type="primary" no="1" @click="createBillingEvent(null)">{{ $t('CargoMsg.Cargo_CreateBill') }}</el-button>
            <el-dropdown
              v-if="role.confirmCharges"
              split-button
              type="primary"
              no="2"
              style="margin:0 5px;"
              @click="commandHandle()"
              @command="p=>{command1=p;commandHandle();}"
            >
              {{ command1 }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('CargoMsg.Cargo_StartReconciliation')">{{ $t('CargoMsg.Cargo_StartReconciliation') }}</el-dropdown-item>
                <el-dropdown-item v-if="$checkPermission(['button_ACTBilling_AutomaticReconciliation'])" :command="$t('CargoMsg.AutomaticReconciliation')">{{ $t('CargoMsg.AutomaticReconciliation') }}</el-dropdown-item>
                <el-dropdown-item v-if="$checkPermission(['button_ACTBilling_AutomaticReconciliation'])" :command="$t('CargoMsg.CheckHistory')">{{ $t('CargoMsg.CheckHistory') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              v-if="role.createInvoiceFromCharges || role.createInvoiceFromApCharges"
              type="primary"
              no="3"
              @click="makeInvoiceEvent"
            >{{ $t('CargoMsg.Cargo_IssuanceReceiptOfInvoice') }}
            </el-button>
            <el-button v-if="role.writeoffCharges" type="primary" no="4" @click="writeoffHandler">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
            <el-button v-if="role.payauthFromCharges" type="primary" no="5" @click="doBillPayment">
              {{ $t('CargoMsg.Cargo_ApplyForPayment') }}
            </el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="6" @click="auditEvent">{{ $t('CargoMsg.Cargo_ChargesAudit') }}</el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="7" @click="auditCancelEvent">{{ $t('CargoMsg.Cargo_CancelAudit') }}
            </el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="8" @click="rejectEvent">{{ $t('CargoMsg.Cargo_ChargesReject') }}</el-button>
            <el-button v-show="!isJobBillType && showBatchGenerateBillingBtn" type="primary" no="9" @click="batchGenerateBilling">{{ $t('CargoMsg.Cargo_BatchCreateBill') }}</el-button>
            <el-button v-show="chargeSubmitDirect && submitChargeRole" type="primary" no="10" @click="submitEventHandler(true)">{{ $t('Billing.chargeList_submission') }}</el-button>
            <el-button v-show="chargeSubmitDirect && cancelSubmitChargeRole" type="primary" no="11" @click="submitEventHandler(false)">{{ $t('Billing.chargeList_cancelSubmit') }}</el-button>
            <el-button v-if="role.auditCharge" type="primary" no="12" @click="chargeAuditOrCancelAudit(true)">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
            <el-button v-if="role.cancelAuditCharge" type="primary" no="13" @click="chargeAuditOrCancelAudit(false)">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
            <el-button v-if="!isJobBillType && role.batchUpdateConfirmSerialNumber && openBatchUpdateConfirmSerialNumber" type="primary" no="14" @click="batchUpdateConfirmSerialNumber">{{ $t('CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumber') }}</el-button>
            <el-button v-if="!isJobBillType && hmToFinanceApi" type="primary" no="15" @click="toManualSyncHM">{{ $t('Clearing.ManualSynchronization') }}</el-button>
            <el-button v-if="role.batchUpload" type="primary" no="batchUpload" @click="batchUploadFileHandler">{{ $t('CargoMsg.Cargo_BatchUploadFile') }}</el-button>
            <el-dropdown
              v-show="!isJobBillType"
              trigger="hover"
              no="batchProcess"
              style="margin:0 5px;"
              @command="batchProcessHandler"
            >
              <el-button type="primary">
                {{ $t('CargoMsg.Cargo_BatchProcess') }}<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="changeAccountId">{{ $t('CargoMsg.Cargo_ChangeSettlement') }}</el-dropdown-item>
                <el-dropdown-item command="changeInvoiceTitle">{{ $t('Partners.modifyInvoicingHeader') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="$checkPermission(['button_ACTBilling_reconciliationInvoicePool']) && !chargeIsAr" type="primary" no="showInvoicePoolDialog" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}</el-button>
            <!-- 指令操作按钮 -->
            <el-button
              v-if="operateReviewRemarkDialog.visible"
              no="reviewRemarks"
              type="primary"
              @click="reviewRemarks()"
            >{{ reviewTitle }}
            </el-button>
            <!-- 指令操作按钮-财务备注 -->
            <el-button
              v-if="financialRemarksDialog.visible"
              no="financialRemarks"
              type="primary"
              @click="financialRemarks()"
            >{{ financialRemarksTitle }}
            </el-button>
            <!-- 指令操作按钮-询证函备注 -->
            <el-button
              v-if="confirmationLetterRemarksDialog.visible"
              no="confirmationLetterRemarks"
              type="primary"
              @click="confirmationLetterRemarks()"
            >{{ confirmationLetterRemarksTitle }}
            </el-button>
          </div>
          <div v-if="currentOptStatus===optStatusDefs.reviewRemarks">
            <el-button type="primary" no="42" @click="cancelReviewRemarks()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            <el-button type="success" no="43" @click="saveReviewRemarks()">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          </div>
          <!--开始对账-->
          <div v-if="currentOptStatus===optStatusDefs.checking">
            <el-button type="primary" no="15" @click="cancelReconciliationBill">{{ $t('CargoMsg.Cargo_CancelReconciliation') }}</el-button>
            <el-button type="success" no="16" @click="saveReconciliationEvent">{{ $t('CargoMsg.Cargo_SaveReconciliation') }}</el-button>
            <el-button type="primary" no="17" @click="processDiffAmountEvent">{{ $t('CargoMsg.Cargo_ProcessingDifference') }}</el-button>
            <el-button type="primary" no="18" @click="batchConfirmEvent">{{ $t('CargoMsg.Cargo_BatchConfirm') }}</el-button>
            <el-button type="primary" no="19" @click="batchCancelConfirmEvent">{{ $t('CargoMsg.Cargo_CancelConfirm') }}</el-button>
          </div>
        </template>
        <template v-slot:searchAreaHeader>
          <extension-conditions
            key="11"
            ref="chargeExtCond"
            no="20"
            :conditions="defaultSearchConditions"
            :bill-type.sync="billType"
            :enabled-bill-type="currentOptStatus===optStatusDefs.checking"
            source="reconciliationByJob"
          />
        </template>
      </search-item>
      <search-item
        v-show="billType==='job'"
        ref="searchItem2"
        key="2"
        :is-append-query="true"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        :search-item-code="$t('Clearing.ReconciliationByBusiness')"
        config-module="5032"
        grid-config-module="190902"
        :auto-init="false"
        :custom-search-items="jobCustomSearchItems"
        :custom-sim-query-placeholder="$t('Clearing.QuickSearchBusinessNumber')"
        :disabled="currentOptStatus===optStatusDefs.checking"
        @query="fetchData"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{jobPerConfigName=value}"
        @refreshGrid="()=>{jobGridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{jobDefaultSearchItems=value}"
      >
        <template slot="operations">
          <div v-if="currentOptStatus===optStatusDefs.normal">
            <el-button type="primary" no="21" @click="createBillingEvent(null)">{{ $t('CargoMsg.Cargo_CreateBill') }}</el-button>
            <el-button v-permission="['button_ACTBilling_confirmCharges']" type="primary" no="22" @click="startReconciliationBill">{{ $t('CargoMsg.Cargo_StartReconciliation') }}</el-button>
            <el-button
              v-if="role.createInvoiceFromCharges || role.createInvoiceFromApCharges"
              type="primary"
              no="23"
              @click="makeInvoiceEvent"
            >{{ $t('CargoMsg.Cargo_IssuanceReceiptOfInvoice') }}
            </el-button>
            <el-button v-permission="['button_ACTBilling_writeoffCharges']" type="primary" no="24" @click="writeoffHandler">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
            <el-button v-permission="['button_ACTBilling_payauthFromCharges']" type="primary" no="25" @click="doBillPayment">
              {{ $t('CargoMsg.Cargo_ApplyForPayment') }}
            </el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="26" @click="auditEvent">{{ $t('CargoMsg.Cargo_ChargesAudit') }}</el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="27" @click="auditCancelEvent">{{ $t('CargoMsg.Cargo_CancelAudit') }}
            </el-button>
            <el-button v-show="!isJobBillType && chargeAuditFlow" type="primary" no="28" @click="rejectEvent">{{ $t('CargoMsg.Cargo_ChargesReject') }}</el-button>
            <el-button v-show="chargeSubmitDirect && submitChargeRole" type="primary" no="29" @click="submitEventHandler(true)">{{ $t('Billing.chargeList_submission') }}</el-button>
            <el-button v-show="chargeSubmitDirect && cancelSubmitChargeRole" type="primary" no="30" @click="submitEventHandler(false)">{{ $t('Billing.chargeList_cancelSubmit') }}</el-button>
            <el-button v-permission="['button_ACTBilling_auditCharge']" type="primary" no="31" @click="chargeAuditOrCancelAudit(true)">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
            <el-button v-permission="['button_ACTBilling_cancelAuditCharge']" type="primary" no="32" @click="chargeAuditOrCancelAudit(false)">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
            <el-button v-if="role.batchUpload" type="primary" no="batchUpload" @click="batchUploadFileHandler">{{ $t('CargoMsg.Cargo_BatchUploadFile') }}</el-button>
            <el-button v-if="$checkPermission(['button_ACTBilling_reconciliationInvoicePool']) && !jobIsAr" type="primary" no="showInvoicePoolDialog" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}</el-button>
            <!-- 指令操作按钮-财务备注 -->
            <el-button
              v-if="financialRemarksDialog.visible"
              no="financialRemarks"
              type="primary"
              @click="financialRemarks()"
            >{{ financialRemarksTitle }}
            </el-button>
            <!-- 指令操作按钮-询证函备注 -->
            <el-button
              v-if="confirmationLetterRemarksDialog.visible"
              no="confirmationLetterRemarks"
              type="primary"
              @click="confirmationLetterRemarks()"
            >{{ confirmationLetterRemarksTitle }}
            </el-button>
          </div>
          <!--开始对账-->
          <div v-if="currentOptStatus===optStatusDefs.checking">
            <el-button type="primary" no="33" @click="cancelReconciliationBill">{{ $t('CargoMsg.Cargo_CancelReconciliation') }}</el-button>
            <el-button type="success" no="34" @click="saveReconciliationEvent">{{ $t('CargoMsg.Cargo_SaveReconciliation') }}</el-button>
            <el-button type="primary" no="35" @click="processDiffAmountEvent">{{ $t('CargoMsg.Cargo_ProcessingDifference') }}</el-button>
            <el-button type="primary" no="36" @click="batchConfirmEvent">{{ $t('CargoMsg.Cargo_BatchConfirm') }}</el-button>
            <el-button type="primary" no="37" @click="batchCancelConfirmEvent">{{ $t('CargoMsg.Cargo_CancelConfirm') }}</el-button>
          </div>
        </template>
        <template v-slot:searchAreaHeader>
          <extension-conditions
            key="12"
            ref="jobExtCond"
            :conditions="defaultSearchConditions"
            :bill-type.sync="billType"
            :enabled-bill-type="currentOptStatus===optStatusDefs.checking"
            source="reconciliationByCharge"
          />
        </template>
      </search-item>
      <div
        v-if="billType === 'job'"
        key="job"
        class="section grid-wrapper"
      >
        <cargo-ag-grid-wrapper
          :key="1"
          config-module="190902"
          :per-config-name="jobPerConfigName"
          :refresh-id="jobGridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="dynamicColumnDefs"
          :sum-column-defs="sumColumnDefsComputed"
          :total-config="totalConfig"
          :row-data="rowData"
          :show-row-groups="dataListDragGroup"
          :pre-column-state-callback="preColumnStateCallback"
        />
      </div>
      <div v-if="billType === 'charge'" key="charge" class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="190901"
          :per-config-name="chargePerConfigName"
          :refresh-id="chargeGridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="dynamicColumnDefs"
          :sum-column-defs="sumColumnDefsComputed"
          :total-config="totalConfig"
          :row-data="rowData"
          :show-row-groups="dataListDragGroup"
          :pre-column-state-callback="preColumnStateCallback"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper">
        <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <div>
            <span v-show="dataShow && totalAmountToCurrency.labelText" style="font-weight: bold;font-size: 13px;" v-text="totalAmountToCurrency.labelText" />
            <span v-show="dataShow" style="font-size: 12px;" v-text="selectionCountLabel" />

          </div>
          <div>
            <span v-show="dataShow && ticketCount > 0" style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_TicketCount') }}</span>
            <span v-show="dataShow && ticketCount > 0" style="font-size: 12px;">{{ ticketCount }}</span>
          </div>
          <div>
            <charge-currency-total-group
              ref="chargeCurrencyTotalGroup1"
              :key="1"
              amount-to-currency=""
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              :data-field="totalAmountToCurrency.dataField"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              :show-wht="showWhtTax"
              ar-field="chargeReceivable"
            />
          </div>
          <div v-show="!showSalePriceHc">
            <span v-show="dataShow && rowData && rowData.length > 0">{{ $t('CargoMsg.Cargo_ReconciliationAmount') }}</span>
            <charge-currency-total-group
              ref="chargeCurrencyTotalGroup2"
              :key="2"
              amount-to-currency=""
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeBillingAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              ar-field="chargeReceivable"
            />
          </div>
          <div v-show="!showSalePriceHc">
            <span v-show="dataShow && rowData && rowData.length > 0">{{ $t('CargoMsg.Cargo_Difference') }}</span>
            <charge-currency-total-group
              ref="chargeCurrencyTotalGroup3"
              :key="3"
              amount-to-currency=""
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeDiffAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              ar-field="chargeReceivable"
            />
          </div>
          <div>
            <charge-currency-total-group
              v-if="reCalc"
              ref="chargeCurrencyTotalGroup3"
              :key="4"
              :amount-to-currency="localCurrency"
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              :data-field="totalAmountToCurrency.dataField"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              ar-field="chargeReceivable"
              :only-show-convert="true"
            />
          </div>
          <div v-show="!showSalePriceHc">
            <charge-currency-total-group
              v-if="reCalc"
              ref="chargeCurrencyTotalGroup5"
              :key="5"
              :amount-to-currency="localCurrency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_ReconciliationAmount')+$t('Clearing.Equivalent')"
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeBillingAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              ar-field="chargeReceivable"
              :only-show-convert="true"
            />
          </div>
          <div v-show="!showSalePriceHc">
            <charge-currency-total-group
              v-if="reCalc"
              ref="chargeCurrencyTotalGroup6"
              :key="6"
              :amount-to-currency="localCurrency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Difference')+$t('Clearing.Equivalent')"
              mode="group"
              :type="totalAmountToCurrency.type"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeDiffAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              :rate-field="totalAmountToCurrency.rateField"
              :arap-group="totalAmountToCurrency.arapGroup"
              ar-field="chargeReceivable"
              :only-show-convert="true"
            />
          </div>
        </div>
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="searchConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-if="billType==='job' && !appendQuery"
          key="job"
          config-module="190901"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
        <cargo-pagination
          v-if="billType==='charge' && !appendQuery"
          key="charge"
          config-module="190902"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <!--创建账单-->
    <bill-detail
      v-if="currentOptStatus===optStatusDefs.billDetailView"
      billing-uuid=""
      :view-billing="false"
      :r-type="billType"
      view-source="reconciliation"
      :new-billing="newBilling"
      :new-charges="newCharges"
      :create-bill-way="createBillWay"
      :accounts="accounts"
      :location="location"
      @cancel="cancelBilling"
      @backReconciliation="backReconciliationEvent"
    />
    <!--创建账单-->
    <split-bill-detail
      v-if="currentOptStatus===optStatusDefs.newBillDetailView"
      billing-uuid=""
      :view-billing="false"
      :reconciliation-type="billType"
      view-source="reconciliation"
      :new-billing="newBilling"
      :new-charges="newCharges"
      :customer-detail="customerDetail"
      :create-bill-way="createBillWay"
      :accounts="accounts"
      :location="location"
      @cancel="cancelBilling"
      @backReconciliation="backReconciliationEvent"
    />
    <!--销账-->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :properties="properties" @writeoffSuccessHandler="reloadData" />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :visible.sync="showBillPaymentDialog"
      :open-sap-config="false"
      :create-submit="true"
      :location="location"
      step="step2"
      mode="overview"
      @cancel="cancelBillPayment"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="reconciliation"
      :location="location"
      @reloadData="reloadData"
    />
    <!--冲突费用明细弹出框-->
    <conflict-charges-dialog
      v-if="showConflictChargeDialog"
      :visible.sync="showConflictChargeDialog"
      :charges="conflictCharges"
      view-source="reconciliation"
      @conflictChargeCallBackEventToReconciliation="conflictChargeCallBackEventToReconciliation"
    />
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 批量生成账单弹出框 -->
    <el-dialog
      :visible.sync="batchGenerateBillingDialog.visible"
      :title="$t('CargoMsg.Cargo_BatchCreateBillTitle')"
      :close-on-click-modal="false"
      :show-close="false"
      width="305px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('CargoMsg.Cargo_BatchCreateBillBySame') }}</span>
        <el-radio-group v-model="batchGenerateBillingDialog.createMode" no="38">
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_BatchCreateBillByAll') }}</el-radio>
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_BatchCreateBillBySelected') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="39" @click="batchGenerateBillingConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="40" @click="batchGenerateBillingCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--批量确认弹出框-->
    <el-dialog
      :visible.sync="batchConfirmDialog.visible"
      :title="$t('CargoMsg.Cargo_ConfirmR')"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="left">
          <el-form-item label-width="0" style="color:blue;">
            <span>{{ $t('CargoMsg.Cargo_ACSWASRATBTSWEAC') }}</span>
          </el-form-item>
          <el-form-item label-width="0">
            <div style="display: flex">
              <span style="color:blue;">{{ $t('CargoMsg.Cargo_ChargeConfirmSerialNumber') }}:</span>
              <el-input
                :value="batchConfirmDialog.confirmSerialNumber|| undefined"
                :controls="false"
                no="41"
                style="padding-left: 10px; width: 170px;"
                @input="value=>{value = value ? value.replace(/[^0-9]/g, '') : ''; this.batchConfirmDialog.confirmSerialNumber=value||''}"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="42" @click="batchConfirmHandler">{{ $t('CargoMsg.Cargo_Yes') }}</el-button>
        <el-button type="primary" no="43" @click="() =>{this.batchConfirmDialog.visible = false;this.batchConfirmDialog.confirmSerialNumber = ''}">{{ $t('CargoMsg.Cargo_No') }}</el-button>
      </div>
    </el-dialog>

    <!--批量修改费用确认批次号弹出框-->
    <el-dialog
      :visible.sync="showBatchUpdateConfirmSerialNumberDialog"
      :title="$t('CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumber')"
      :close-on-click-modal="false"
      :show-close="false"
      width="350px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item label-width="0" style="color:blue;">
            <span>{{ $t('CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumberTip') }}</span>
          </el-form-item>
          <el-form-item label-width="0">
            <el-form-item label-width="0">
              <div style="display: flex">
                <span style="color:blue;">{{ $t('CargoMsg.Cargo_ChargeConfirmSerialNumber') }}:</span>
                <el-input
                  :value="confirmSerialNumber|| undefined"
                  :controls="false"
                  no="44"
                  :placeholder="$t('CargoMsg.Cargo_InputChargeConfirmSerialNumber')"
                  style="padding-left: 10px; width: 170px;"
                  @input="value=>{value = value ? value.replace(/[^0-9]/g, '') : ''; this.confirmSerialNumber=value||''}"
                />
              </div>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="45" @click="batchUpdateConfirmSerialNumberHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button type="primary" no="46" @click="() =>{this.showBatchUpdateConfirmSerialNumberDialog = false;this.confirmSerialNumber = ''}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 导入模板方案 -->
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="importFormDialog"
      :title="dialogTitle"
      width="500px"
    >
      <div class="app-main-inner-row">
        <div v-show="dialogTitle === $t('Clearing.SelectImportTemplateSolution')" style="margin:0 auto;">
          <span>{{ $t('Clearing.TemplateSolutionName') }}</span>
          <el-select
            v-model="solutionsValue"
            filterable
            style="width:300px;margin-left:10px;"
            :placeholder="plan"
          >
            <el-option
              v-for="(item, index) in solutionsNameList"
              :key="index"
              :label="item.templateName"
              :value="item.uuid"
            />
          </el-select>
          <p style="margin:10px 0 0 82px;">{{ $t('Clearing.ToMaintainImportTemplatesClick') }}
            <span style="color:#4283ff;cursor:pointer;" @click="jump">{{ $t('Clearing.BasicDataImportTemplateSolutions') }}</span>
          </p>
        </div>
        <div v-show="dialogTitle === $t('Clearing.Prompt')" style="margin:0 auto;">
          <span>导入成功{{ successOrFailure.succeed }}条，导入失败{{ successOrFailure.failure }}条，是否下载导入失败的文件？</span>
        </div>
      </div>
      <div slot="footer">
        <el-upload
          v-show="dialogTitle === $t('Clearing.SelectImportTemplateSolution') && solutionsValue"
          action="string"
          :http-request="importExcelEventHandler"
          :show-file-list="false"
          accept=".xls, .xlsx"
          :before-upload="beforeUploadUsage"
          style="display: inline-block;padding-left: 5px;"
        >
          <el-button type="primary" no="47" size="mini" @click="theImport">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        </el-upload>
        <el-button v-show="!solutionsValue" type="primary" no="48" size="mini" @click="theImport">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button v-show="dialogTitle === $t('Clearing.Prompt')" type="primary" no="49" size="mini" @click="download">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" no="50" @click="importFormDialog=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 费用审核-->
    <charge-check-dialog v-if="showChargeCheckDialog" :visible.sync="showChargeCheckDialog" :info="{ title: $t('CargoMsg.Cargo_EditFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" @confirm="chargeAuditConfirmCB($event)" />

    <!-- 云文件上传对话框 -->
    <batch-upload-file
      :visible.sync="cloudFile.visible"
      :redis-key="cloudFile.redisKey"
      :job-num="cloudFile.num"
      page-source="tabReconciliation"
      :lob="cloudFile.lob"
    />

    <!-- 财务备注弹框 -->
    <el-dialog
      :visible.sync="financialRemarksFormDialog.visible"
      :title="$t('CargoMsg.Cargo_FinancialRemarks')"
      :close-on-click-modal="false"
      :show-close="false"
      width="500px"
    >
      <div class="app-main-inner-row" style="flex-direction: column; padding-bottom: 10px;">
        <el-form label-width="80px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_FinancialRemarks')">
            <el-input
              v-model="financialRemarksFormDialog.remarks"
              type="textarea"
              :rows="3"
              maxlength="512"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div style="color: #999; font-size: 12px; margin-top: 10px;">
          {{ $t('Billing.WarmPromptAppend') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFinancialRemarks">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button @click="cancelFinancialRemarks">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 询证函备注弹框 -->
    <el-dialog
      :visible.sync="confirmationLetterRemarksFormDialog.visible"
      :title="$t('Billing.InquiryLetterRemark')"
      :close-on-click-modal="false"
      :show-close="false"
      width="500px"
    >
      <div class="app-main-inner-row" style="flex-direction: column; padding-bottom: 10px;">
        <el-form label-width="80px" label-position="left">
          <el-form-item :label="$t('Billing.InquiryLetterRemark')">
            <el-input
              v-model="confirmationLetterRemarksFormDialog.remarks"
              type="textarea"
              :rows="3"
              maxlength="512"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div style="color: #999; font-size: 12px; margin-top: 10px;">
          {{ $t('Billing.WarmPromptOverwrite') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveConfirmationLetterRemarks">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button @click="cancelConfirmationLetterRemarks">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 发票池弹窗 -->
    <change-account-id-dialog
      :visible.sync="changeAccountIdDialog.visible"
      :is-ar="changeAccountIdDialog.isAr"
      :company-factory-signs="changeAccountIdDialog.companyFactorySigns"
      :default-account-id="0"
      :required="true"
      :show-before-after="changeAccountIdDialog.showBeforeAfter"
      :before-account-id="changeAccountIdDialog.beforeAccountId"
      :settlement-active-only="false"
      @changeAccountId="onBatchChangeAccountIdConfirm"
    />
    <change-invoice-title-dialog
      :visible.sync="changeInvoiceTitleDialog.visible"
      :account-id="changeInvoiceTitleDialog.accountId"
      :default-invoice-title="changeInvoiceTitleDialog.defaultInvoiceTitle"
      :required="true"
      :show-before-after="changeInvoiceTitleDialog.showBeforeAfter"
      :before-invoice-title="changeInvoiceTitleDialog.beforeInvoiceTitle"
      @changeInvoiceTitle="onBatchChangeInvoiceTitleConfirm"
    />
    <invoice-pool-dialog
      v-if="invoicePoolDialog.visible"
      :visible.sync="invoicePoolDialog.visible"
      :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
      :selected-entities="invoicePoolDialog.selectedEntities"
      :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
      :operation="invoicePoolDialog.operation"
      :source="invoicePoolDialog.source"
    />

  </div>
</template>

<script>
/* eslint-disable no-case-declarations */
import { chargeItemLanguage, DocumentManage, ensureExecuteSuccess, stringToBool } from '@/utils/commonUtil'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  getReconciliationChargeList,
  getReconciliationJobList, updateChargeReviewRemark, updateConfirmationLetterRemarks, updateFinancialRemarks,
  batchUpdateChargeAccountId, batchUpdateChargeInvoiceTitle
} from '@/api/clearing/billingNative'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import { getUserPrivileges } from '@/api/auth'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import extensionConditions from './extensionConditions'
import * as ReconciliationUtils from '@/class/cargo/model/utils/ReconciliationUtils'
import billDetail from './billDetail'
import splitBillDetail from './splitBillDetail'
import { getGridSelected } from '@/utils/agGrid'
import {
  checkCharge,
  sendHecMessageByCharge,
  doHmSyncZgChargeToYongYou,
  queryJobByChargeKeysFunc,
  validateChargeHasUpdate
} from '@/api/clearing/charge'
import conflictChargesDialog from '@/views/cargo/v0/Clearing/components/BillingNative/conflictChargesDialog'
import { saveReconciliation, batchGenerateBilling } from '@/api/clearing/billingNative'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as NumberUtils from '@/utils/NumberUtils'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import DateUtils from '@/utils/dateUtils'
import { Assert } from '@/utils/validate'
import { getNotInvoiceCharges } from '@/api/clearing/invoice'
import { putAuditCharges, rejectCharges, getChargeForBillPayment, chargeSubmit, loadCharges, chargeAuditOrCancelAudit, batchUpdateConfirmSerialNumber } from '@/api/clearing/charge'
import { formatNumberToThousands } from '@/utils'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { Once } from '@/utils/commonUtil'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import moment from 'moment'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { BuriedPointUtils } from '@/utils/BuriedPointUtils'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import {
  OPERATOR_EQUAL,
  OPERATOR_UNEQUAL,
  OPERATOR_IN,
  OPERATOR_NOT_IN,
  FIELD_OPERATOR_MAP
} from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { importReconciliationBill } from '@/api/clearing/tabAutomaticReconciliation'
import { queryTemplateList } from '@/api/ImportingTemplate'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { Company } from '@/class/model/mdm/Company'
import { getJumpFinaceOrBusinessAttrs } from '@/components/Cargo/grid/routerAndPrintHelp'
import { getBankAccountList } from '@/api/bankAccount'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import { isSameSettlementAgent2, isSameSettlementAgentByJob2, isSameAccountByJob, isSameAccount, getSettlementAgentIdByJob, getSettlementAgentIdByCharge } from '@/class/cargo/model/utils/ReconciliationUtils'
import chargeCheckDialog from '@/views/cargo/v0/Clearing/components/financeManage/changeDialog'
import { batchUpdateChargeState } from '@/api/clearing/financeManage'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { LOG_RECONCILIATION } from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'
import $store from '@/store'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import URL from '@/api/urlTranslator'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import { isNumber2 } from '@/utils/validate'
import batchUploadFile from '@/components/Cargo/Common/batchUploadFile.vue'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { getInstructions } from '@/api/sysManage/uiCustom'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index.vue'
import invoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog.vue'
import ChangeAccountIdDialog from '@/components/Cargo/Job/changeAccountIdDialog.vue'
import ChangeInvoiceTitleDialog from '@/components/Cargo/Job/changeInvoiceTitleDialog.vue'
import {
  buildChargeEditPrivilege,
  normalizeReconciliationCharge,
  isReconciliationChargeShareEnabled,
  checkRoleEdit,
  formatReconciliationChargeLabel
} from '@/class/cargo/model/utils/ReconciliationChargeEditUtil'

export default {
  name: 'TabReconciliation',
  components: {
    ChangeInvoiceTitleDialog,
    ChangeAccountIdDialog,
    invoicePoolDialog,
    batchUploadFile,
    chargeCheckDialog,
    searchItem,
    writeOffDialog,
    billPaymentDialog,
    extensionConditions,
    billDetail,
    conflictChargesDialog, // 冲突费用明细弹出框
    makeInvoiceDialog, // 开票/收票弹出框
    cargoTemplateSelectorDialog,
    splitBillDetail,
    ChargeCurrencyTotalGroup, // 合计组件
    cargoAgGridWrapper
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      solutionsNameList: [],
      solutionsValue: '',
      successOrFailure: {
        succeed: 0,
        failure: 0
      },
      filterParameters: {},
      importFailure: '',
      plan: this.$t('Clearing.PleaseSelectASolution'),
      dialogTitle: this.$t('Clearing.SelectImportTemplateSolution'),
      importFormDialog: false, // 选择导入模板方案弹窗
      command1: this.$t('CargoMsg.Cargo_StartReconciliation'),
      dataShow: true, // 底部计算组件文字是否显示
      selectedJob: {},
      loading: false,
      jobCustomSearchItems: [], // 自定义高级查询项
      chargeCustomSearchItems: [], // 自定义高级查询项
      jobDefaultSearchItems: [],
      chargeDefaultSearchItems: [],
      showWriteOffDialog: false,
      showBillPaymentDialog: false,
      documentManage: new DocumentManage(),
      diffChargeByBillingAmountPattern: 0,
      optStatusDefs: {
        checking: 'checking', // 开始对账中
        normal: 'normal', // 初始状态-无操作
        billDetailView: 'billDetailView', // 账单详情页
        reviewRemarks: 'reviewRemarks', // 审核备注
        newBillDetailView: 'newBillDetailView' // 账单详情页
      },
      currentOptStatus: 'normal',
      grid: {
        isEdit: false
      },
      billType: 'charge',
      chargePerConfigName: '',
      chargeGridRefreshId: 0,
      jobPerConfigName: '',
      jobGridRefreshId: 0,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sumColumnDefs: [
        {
          field: 'chargeQuantity',
          getValue: data => data.chargeQuantity,
          format: value => value
        },
        {
          field: 'chargeAmount',
          getValue: data => data.chargeAmount,
          format: value => !value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(value), 2), 2)
        },
        {
          field: 'chargeExcludingTaxAmount',
          getValue: data => data.chargeExcludingTaxAmount,
          format: value => !value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(value), 2), 2)
        },
        {
          field: 'chargeTaxAmount',
          getValue: data => data.chargeTaxAmount,
          format: value => !value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(value), 2), 2)
        },
        {
          field: 'chargeVerifiedAmount',
          getValue: data => data.chargeVerifiedAmount,
          format: value => !value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(value), 2), 2)
        },
        {
          field: 'chargeUnverifiedAmount',
          getValue: data => data.chargeUnverifiedAmount,
          format: value => !value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(value), 2), 2)
        },
        {
          field: 'chargeBillingAmount',
          getValue: data => data.chargeBillingAmount,
          format: value => this.$numeral(value).format('0.00')
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [], // agGrid 显示的数据源
      rowDataCharge: [], // 按费用的行数据()
      rowDataJob: [], // 按业务的行数据()
      rowDataBackup: [], // 行数据备份，取消对账时使用
      defaultSearchConditions: {
        isAr: 1, // 应收/应付
        advance: -1, //  是否垫付
        oversea: 0, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: -1, // 是否关联账单
        isShowWriteOff: true, // 是否过滤全部核销数据
        shared: 0, // 是否分摊费用
        businessDate: [], // 业务日期,
        customConditions: [], // 自定义约束条件
        internalCharge: false // 内结
      },
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      searchConditionsJob: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      searchConditionsCharge: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      requires: ['writeoff', 'invoice'],
      showFba: false, // 显示FBA相关列
      newBillDialog: { // 账单弹出框
        visible: false,
        customerDetail: {},
        billingUuid: '',
        isView: false
      },
      customerDetail: {},
      newBilling: {}, // 创建账单时新的账单对象
      newCharges: [], // 创建账单时关联的费用
      saveCharges: [], // 对账，点击保存时的费用
      conflictCharges: [], // 有冲突的费用集合
      showConflictChargeDialog: false, // 是否显示费用冲突弹出框
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 0
      },
      showLoading: true, // 是否显示加载中样式
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: []
        }
      },
      chargeAuditFlow: false, // 费用审批流程
      totalAmountToCurrency: { // 右下角合计组件相关参数
        labelText: '',
        dataProvider: [], // 数据源
        dataChargeProvider: [], // 数据源
        dataJobProvider: [], // 数据源
        dataField: 'chargeAmount',
        currencyField: 'chargeCurrency',
        rateField: 'chargeExchangeRate',
        type: 'auto',
        arapGroup: false
      },
      showColumnsVisible: { // 控制显示列是否隐藏
        showVerifiedAmount: false, // 已核销金额
        showUnverifiedAmount: false, // 未核销金额
        showCommonChargeState: false, // 费用确认状态
        showInvoiceNo: true // 发票号
      },
      once: new Once(this),
      selectedCount: 0,
      clearSelectionOnLoad: false,
      beforeConditions: null, // 记录上一次的查询条件，导出全部使用
      shouldFixed: false,
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      },
      writeOffDialog: { visible: false },
      totalConfig: null,
      queryOfficeId: 0, // 记录查询时的分公司Id
      updateRows: false,
      showBatchGenerateBillingBtn: false, // 批量生成账单
      batchGenerateBillingDialog: {
        visible: false,
        createMode: 0, // 0:查出的全部记录；1:选中的记录
        conditions: []
      },
      chargeSubmitDirect: false, // 是否直接提交审核费用
      cancelSubmitChargeRole: false, // 取消提交费用权限
      submitChargeRole: false, // 提交费用权限
      role: {
        confirmCharges: false,
        createInvoiceFromCharges: false,
        createInvoiceFromApCharges: false,
        writeoffCharges: false,
        payauthFromCharges: false,
        auditCharge: false,
        cancelAuditCharge: false,
        batchUpload: false, // 批量上传
        batchUpdateConfirmSerialNumber: false // 批量修改批次
      },
      cloudFile: {
        visible: false,
        lob: 'SE',
        num: 0,
        redisKey: ''
      },
      appendQuery: false, // 追加查询
      showBatchUpdateConfirmSerialNumberDialog: false, // 是否显示批量修改批次号弹出框，
      confirmSerialNumber: '', // 费用确认批次
      batchConfirmDialog: { // 批量确认弹窗
        visible: false,
        confirmSerialNumber: ''
      },
      operateReviewRemarkDialog: {
        visible: false
      },
      reviewEditDialog: {
        visible: false
      },
      reviewTitle: '',
      financialRemarksTitle: '',
      financialRemarksDialog: {
        visible: false
      },
      financialRemarksFormDialog: {
        visible: false,
        remarks: ''
      },
      confirmationLetterRemarksTitle: '',
      confirmationLetterRemarksDialog: {
        visible: false
      },
      confirmationLetterRemarksFormDialog: {
        visible: false,
        remarks: ''
      },
      changeAccountIdDialog: {
        visible: false,
        isAr: false,
        companyFactorySigns: [],
        showBeforeAfter: false,
        beforeAccountId: 0
      },
      changeInvoiceTitleDialog: {
        visible: false,
        accountId: 0,
        defaultInvoiceTitle: '',
        showBeforeAfter: false,
        beforeInvoiceTitle: ''
      },
      batchProcessChargeUuids: [],
      chargeEditPrivilege: {},
      openBatchUpdateConfirmSerialNumber: false, // 是否开启批量修改费用确认批次号配置
      // 银行账户列表（列表渲染使用）
      bankAccounts: null,
      officeIdForDepartmentMap: new Map(), // 分公司和对应部门Map
      createBillWay: 0, // 创建账单方式【0：结算对象 1、结算代理】
      accounts: [],
      allCharges: [], // 当前选中的所有费用
      showChargeCheckDialog: false,
      sapChargeList: [],
      location: LOG_RECONCILIATION.code,
      hmToFinanceApi: false,
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        operation: '',
        source: 'reconciliation',
        makeInvoiceMethod: 1
      },
      chargeIsAr: true,
      jobIsAr: true,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      showSalePriceHc: false // 显示销售单价hc权限：有此权限时隐藏相关字段，在created中异步赋值
    }
  },
  computed: {
    // 合计列定义：有显示销售单价hc权限时过滤掉核销金额、未销金额
    sumColumnDefsComputed() {
      if (this.showSalePriceHc) {
        return this.sumColumnDefs.filter(c => c.field !== 'chargeVerifiedAmount' && c.field !== 'chargeUnverifiedAmount')
      }
      return this.sumColumnDefs
    },
    // 列状态预处理：有显示销售单价hc权限时强制隐藏核销金额、未销金额、对账金额、差价列，防止localStorage缓存覆盖
    preColumnStateCallback() {
      return columnState => {
        if (this.showSalePriceHc) {
          columnState.forEach(state => {
            if (state.colId === 'chargeVerifiedAmount' || state.colId === 'chargeUnverifiedAmount' || state.colId === 'chargeBillingAmount' || state.colId === 'chargeDiffAmount') {
              state.hide = true
            }
          })
        }
        return columnState
      }
    },
    isJobBillType() {
      return this.billType === 'job'
    },
    ticketCount() {
      const source = this.totalAmountToCurrency.dataProvider && this.totalAmountToCurrency.dataProvider.length > 0
        ? this.totalAmountToCurrency.dataProvider
        : this.rowData
      const jobNos = new Set(
        (source || [])
          .map(item => item && item.jobJobNo)
          .filter(Boolean)
      )
      return jobNos.size
    },
    selectionCount() {
      return this.selectedCount
    },
    selectionCountLabel() {
      return this.$t('CargoMsg.Cargo_ChooseP', [this.selectionCount])
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode
    },
    dynamicColumnDefs() {
      // billType
      let columnDefs = [
        {
          headerName: '', initialWidth: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
          field: 'khPlateNumber',
          colId: 'khPlateNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'khTrailerNumber',
          colId: 'khTrailerNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'jobProjectName',
          colId: 'jobProjectName',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          colId: 'scNo',
          field: 'scNo',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContractRateProperty'),
          colId: 'bookingTerm',
          field: 'bookingTerm',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.bookingTermSILabelFunction(params.data, params.value)
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.ActualTimeOfArrivalThePort'),
          field: 'jobRealArrivalsDate',
          colId: 'jobRealArrivalsDate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessModel'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunctionForAllBusiness(params.data, 'containerLoadType')
          },
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.MBLTransportationClause'),
          field: 'jobFreightTerm',
          colId: 'jobFreightTerm',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLTransportationClause'),
          field: 'jobFreightTermHBL',
          colId: 'jobFreightTermHBL',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'),
          field: 'financialRemarks',
          initialWidth: 200,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Billing.InquiryLetterRemark'),
          field: 'confirmationLetterRemarks',
          initialWidth: 200,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 150
        }
      ]
      if (!this.isJobBillType) {
        columnDefs = [
          ...columnDefs,
          {
            headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: params => {
                if (!params.data) {
                  return {}
                }
                const data = params.data
                return getJumpFinaceOrBusinessAttrs(true, true, data.jobJobNo, data.jobLob, data.chargeBranchId, this.toFinanceChargeTab)
              }
            }
          },
          { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', initialWidth: 200 },
          { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', initialWidth: 200 },
          {
            headerName: this.$t('SeaExport.DocCutOffDate'), field: 'jobFileCutoff', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.soNoLabelFunc2(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.containerNo'), field: 'jobContainerNo', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.FieldOperation'), field: 'jobSiteOp', colId: 'jobSiteOp', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.billPaymentNo'), field: 'billPaymentBillPaymentNo', initialWidth: 200 },
          {
            headerName: this.$t('Payment.eta'), field: 'jobEta', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.etd'), field: 'jobEtd', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.atd'), field: 'jobAtd', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: false,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.ata'), field: 'jobAta', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: false,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.exchangeRate'), field: 'chargeExchangeRate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 8)
            },
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.billNo'), field: 'billingBillingNo', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.cargoSourceLabelFunction(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.mbl'), field: 'jobMbl', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.separateNumber'), field: 'jobImportHbl', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.businessType'), field: 'jobLob', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Partners.isFba'),
            colId: 'fba',
            field: 'fba',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.DestinationDistribution'),
            colId: 'destinationDistribution',
            field: 'destinationDistribution',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ExpressNo'),
            colId: 'expressNo',
            field: 'expressNo',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.RemoteWarehouse'),
            colId: 'remoteWarehouse',
            field: 'remoteWarehouse',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ShipmentId'),
            colId: 'shipmentId',
            field: 'shipmentId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ReferenceId'),
            colId: 'referenceId',
            field: 'referenceId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVesselFlight', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              } else {
                return ''
              }
            },
            filter: false,
            filterParams: {}
          },
          {
            headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              } else {
                return ''
              }
            },
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('CargoMsg.Cargo_BookingAgent'), field: 'jobBookingAgent', width: 100, colId: 'jobBookingAgent',
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.sales'), field: 'jobSales', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.operation'), field: 'jobOp', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.customerService'), field: 'jobCsr', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.Documents'), field: 'jobDc', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', initialWidth: 200,
            valueGetter: (params) => {
              return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.financialDate'), field: 'chargeAccountingDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.domesticInternational'), field: 'chargeOversea', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.overseaLabelFunc(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.isReceivable'), field: 'chargeReceivable', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.feeStatus'), field: 'chargeChargeState', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.chargeStateLabFun(Number(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.auditor'), field: 'chargeAuditor', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.confirmationStatus'), field: 'chargeConfirmState', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.chargeConfirmStateLabFun(Number(params.value))
            },
            hide: this.showColumnsVisible.showCommonChargeState,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.unit'), field: 'chargeMeasure', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.chargeMeasureLabelFun(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.quantity'), field: 'chargeQuantity', initialWidth: 200, enableRowGroup: true,
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.000')
            },
            filterParams: {},
            filterValueGetter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.data.chargeQuantity).format('0.000') // 格式化筛选值
            },
            summaryMode: 'sum' },
          {
            headerName: this.$t('Payment.unitPrice'), field: 'chargeUnitRate', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.numberColumnLabelFunc(Number(params.value), 2)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'chargeVerifiedAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            hide: this.showColumnsVisible.showVerifiedAmount || this.showSalePriceHc,
            suppressColumnsToolPanel: this.showSalePriceHc,
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
            },
            hide: this.showColumnsVisible.showUnverifiedAmount || this.showSalePriceHc,
            suppressColumnsToolPanel: this.showSalePriceHc,
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          { headerName: this.$t('Payment.contactPerson'), field: 'chargeContactPerson', initialWidth: 200, hide: true, enableRowGroup: true },
          {
            headerName: this.$t('Payment.creator'), field: 'chargeCreatedBy', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.remarks'), field: 'chargeRemarks', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', initialWidth: 200, hide: true, enableRowGroup: true },
          {
            headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_6')
              } else {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            },
            filterParams: {},
            filterValueGetter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'auto_5')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'auto_6')
              } else {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'chineseName')
              }
            },
            hide: true
          },
          {
            headerName: this.$t('Payment.confirmDate'), field: 'chargeConfirmDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.confirmUser'), field: 'chargeConfirmUser', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.planner'), field: 'jobPlanner', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.invoiceDateAll'), field: 'invoiceInvoiceDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.invoiceNo'), field: 'chargeInvoiceNo', initialWidth: 200, hide: this.showColumnsVisible.showInvoiceNo, enableRowGroup: true },
          { headerName: this.$t('Payment.invoiceHeader'), field: 'chargeInvoiceTitle', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_sellTitle'), field: 'sellTitle', colId: 'sellTitle', initialWidth: 200, hide: true, enableRowGroup: true },
          {
            headerName: this.$t('Payment.isNeedInvoice'), field: 'chargeNeedInvoice', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.writeOffDate'), field: 'chargeClearingDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.jobStateLabelFunc(Number(params.value))
            },
            enableRowGroup: true
          },
          { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargeDateOfDeparture'), field: 'bargeEtd', initialWidth: 200, hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('SeaExport.BargeVessel'), field: 'bargeVessel', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargeVoyage'), field: 'bargeVoyage', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargePortOfLoading'), field: 'bargePol', initialWidth: 200, hide: true, enableRowGroup: true },
          {
            headerName: this.$t('Payment.payReceiveDate'), field: 'chargePayReceiveDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.SalesDepartment'), field: 'jobSalesDepartment', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('SeaExport.DeliveryTime'), field: 'jobDestPortDeliveryTime', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.confirmRemarks'), field: 'chargeConfirmRemarks', initialWidth: 200,
            editable: params => ReconciliationUtils.checkEditable(params.data) && this.grid.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.moneyWriteOffStatus'), field: 'realClearingState',
            cellRenderer: (params) => {
              return ColumnUtils.realClearingStateLabFun(params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.realClearingStateLabFun(params.data.realClearingState)
            },
            initialWidth: 100
          },
          {
            headerName: this.$t('SeaExport.OperationDate'), field: 'jobCustomsDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'), field: 'truckingLoadingDate', initialWidth: 200, enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.ActualReturnTime'),
            field: 'destPortReturnTime',
            colId: 'destPortReturnTime',
            width: 150,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.ContainerDescription'),
            field: 'jobContainerDesc',
            valueFormatter: (params) => {
              return ColumnUtils.containerDescLabelFunc(params.value)
            },
            initialWidth: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.FeeCreationDate'),
            field: 'chargeDateCreated',
            valueFormatter: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            },
            initialWidth: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_CustomerLevel'),
            field: 'customerTypeId',
            cellRenderer: (params) => {
              return ColumnUtils.companyCustomerTypeLabelFunc(params.value)
            },
            filter: false,
            filterParams: {},
            hide: true,
            initialWidth: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.DeliveryCompletionDate'),
            field: 'deliveryCompletionDate',
            valueFormatter: (params) => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            initialWidth: 150,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'chargeChanger',
            field: 'chargeChanger',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SettlementAgent'),
            colId: 'chargeSettlementAgentId',
            field: 'chargeSettlementAgentId',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AdjustExpenseOrNot'), colId: 'chargeAdjustment', field: 'chargeAdjustment', initialWidth: 150,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            filter: false,
            filterParams: {},
            initialHide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('queryJob.route'),
            field: 'jobTransportLine',
            colId: 'jobTransportLine',
            valueFormatter: (params) => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            initialWidth: 200,
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_FeeModifyDate'), field: 'chargeDateModified', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_FeeModifier'), field: 'chargeModifiedBy', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.InputDate'),
            field: 'billingInputDate',
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            initialWidth: 150,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DueDate'),
            field: 'billingDueDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AgentBillNo'),
            colId: 'counterPartyBillingNo',
            field: 'counterPartyBillingNo',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return params.value
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('queryJob.receivablesWriteOfStatus'),
            colId: 'verifyStateReceivable',
            field: 'verifyStateReceivable',
            width: 180,
            valueFormatter: (params) => {
              return ColumnUtils.writeOffStateLabFun(params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.writeOffStateLabFun(params.data.verifyStateReceivable)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
            field: 'userDefinedRoleId1',
            colId: 'userDefinedRoleId1',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
            field: 'userDefinedRoleId2',
            colId: 'userDefinedRoleId2',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader4'),
            field: 'userDefinedRoleId4',
            colId: 'userDefinedRoleId4',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_NominatedAgent'),
            field: 'jobDesignationAgent',
            colId: 'jobDesignationAgent',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.CargoActArrivalDatePacking'),
            field: 'jobActLoadingDate',
            colId: 'jobActLoadingDate',
            hide: true,
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('Billing.billingJob_otherPartyBilling'),
            field: 'otherPartyBilling',
            colId: 'otherPartyBilling',
            hide: true,
            width: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('Billing.DueDate'),
            colId: 'chargeDueDate',
            field: 'chargeDueDate',
            width: 120,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_AssociatedExpenseID'),
            colId: 'chargeRelatedId',
            field: 'chargeRelatedId',
            width: 120,
            valueFormatter: params => {
              if (Number(params.value) && Number(params.value) > 0) {
                return params.value
              }
              return ''
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChargeID'),
            colId: 'chargeChargeId',
            field: 'chargeChargeId',
            width: 120,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.ChargeSource'),
            colId: 'chargeSource',
            field: 'chargeSource',
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.chargeSourceLabel(Number(params.value))
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_ExpenseBoxNo'),
            field: 'chargeRelationContainerNo',
            initialWidth: 200,
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
            field: 'jobDispatchingPlace',
            colId: 'jobDispatchingPlace',
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
            field: 'actTakeTime',
            colId: 'actTakeTime',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_WriteOffBank'),
            field: 'ourBank',
            colId: 'ourBank',
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Partners.ParentCompany'), field: 'globalAccountUuid', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'uuid', Number(params.value), 'auto_accountId') : ''
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.settleDepartmentPrefix'), field: 'settleDepartmentPrefix', initialWidth: 200,
            valueFormatter: (params) => {
              const options = this.getDepartmentsByOfficeUuid(params.data.chargeBranchId)
              const curOption = options.find(option => option.jobNoPrefix === params.value)
              if (curOption) {
                return curOption.chineseName
              }
              return ''
            },
            filterParams: {},
            filterValueGetter: (params) => {
              const options = this.getDepartmentsByOfficeUuid(params.data.chargeBranchId)
              const curOption = options.find(option => option.jobNoPrefix === params.data.settleDepartmentPrefix)
              if (curOption) {
                return curOption.chineseName
              }
              return ''
            }
          }, {
            headerName: this.$t('SeaExport.SalesOfGoods'),
            colId: 'cargoSalesId',
            field: 'cargoSalesId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            width: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
            field: 'salesOffice',
            colId: 'salesOffice',
            hide: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
            field: 'opOffice',
            colId: 'opOffice',
            hide: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeSyncStatus'),
            colId: 'chargeSyncStatus',
            field: 'chargeSyncStatus',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(Number(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.BillExchangeAgent'),
            field: 'exChangeAgent',
            colId: 'exChangeAgent',
            hide: true,
            cellRenderer: (params) => {
              if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
                return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
              }
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('FinanceManage.CostType'),
            colId: 'chargeCostControlType',
            field: 'chargeCostControlType',
            width: 120,
            valueFormatter: (params) => {
              const isZh = $store.getters.language === 'zh'
              return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_BusinessCreateDate'),
            field: 'jobDateCreated',
            initialWidth: 200,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Billing.billingJob_ReviewRemarks'),
            field: 'reviewRemarks',
            initialWidth: 200,
            editable: this.reviewEditDialog.visible,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            onCellValueChanged: p => this.onCellChange(p),
            hide: true,
            enableRowGroup: true
          }
        ]
        if (this.showWhtTax) {
          columnDefs.push({
            headerName: this.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxLocalAmount', width: 100,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
            },
            summaryMode: 'sum'
          }, {
            headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'chargeNotWhtAmount',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          })
        }
        if (this.hmToFinanceApi) {
          columnDefs.push(
            {
              headerName: this.$t('Clearing.CostSyncColudStatus'),
              field: 'chargeSyncExternalStatus',
              initialWidth: 100,
              valueFormatter: (params) => {
                return ColumnUtils.hmYongYouSyncStatusLabelFunc(params.value)
              }
            },
            {
              headerName: this.$t('Clearing.SyncCloudExceptionReason'),
              field: 'chargeSyncExternalFailReason',
              initialWidth: 200
            }
          )
        }
      } else if (this.isJobBillType) {
        columnDefs = [
          ...columnDefs,
          {
            headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: params => {
                if (!params.data) {
                  return {}
                }
                const data = params.data
                const chargeBranchIds = data.chargeBranchId ? data.chargeBranchId.split(',') : []
                const firstChargeBranchId = chargeBranchIds.length > 0 ? chargeBranchIds[0] : ''
                return getJumpFinaceOrBusinessAttrs(true, true, data.jobJobNo, data.jobLob, firstChargeBranchId, this.toFinanceChargeTab)
              }
            }
          },
          { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.soNoLabelFunc2(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.DocCutOffDate'), field: 'jobFileCutoff', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'jobEta', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ETD'), field: 'jobEtd', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ATD'), field: 'jobAtd', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: false,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ATA'), field: 'jobAta', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: false,
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.mbl'), field: 'jobMbl', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.separateNumber'), field: 'jobHbl', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.containerNo'), field: 'containerContainerNo', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.FieldOperation'), field: 'jobSiteOp', colId: 'jobSiteOp', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.cargoSourceLabelFunction(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Partners.isFba'),
            colId: 'fba',
            field: 'fba',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.DestinationDistribution'),
            colId: 'destinationDistribution',
            field: 'destinationDistribution',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ExpressNo'),
            colId: 'expressNo',
            field: 'expressNo',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.RemoteWarehouse'),
            colId: 'remoteWarehouse',
            field: 'remoteWarehouse',
            width: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ShipmentId'),
            colId: 'shipmentId',
            field: 'shipmentId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('FbaJob.ReferenceId'),
            colId: 'referenceId',
            field: 'referenceId',
            width: 180,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.carrier'), field: 'jobCarrierId', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_6')
              } else {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            },
            filterParams: {},
            filterValueGetter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'auto_5')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'auto_6')
              } else {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobCarrierId, 'chineseName')
              }
            }
          },
          {
            headerName: this.$t('Payment.businessType'), field: 'jobLob', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', initialWidth: 200,
            valueGetter: (params) => {
              return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              } else {
                return ''
              }
            },
            filter: false,
            filterParams: {}
          },
          {
            headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', initialWidth: 200,
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              } else {
                return ''
              }
            },
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('CargoMsg.Cargo_BookingAgent'), field: 'jobBookingAgent', width: 100, colId: 'jobBookingAgent',
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.operation'), field: 'jobOp', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.sales'), field: 'jobSales', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
            field: 'jobSalesOffice',
            colId: 'jobSalesOffice',
            hide: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.customerService'), field: 'jobCsr', initialWidth: 200,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.Documents'), field: 'jobDc', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', initialWidth: 200, enableRowGroup: true },
          {
            headerName: this.$t('Payment.planner'), field: 'jobPlanner', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.invoicingMethod'), field: 'customerDetailInvoiceMode', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.invoiceModeLabelFun(Number(params.value))
            },
            hide: true
          },
          {
            headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.invoiceHeader'), field: 'invoiceTitle', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('Invoice.invoice_sellTitle'), field: 'sellTitle', colId: 'sellTitle', initialWidth: 200, hide: true, enableRowGroup: true },
          {
            headerName: this.$t('Payment.isNeedInvoice'), field: 'chargeNeedInvoice', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.jobStateLabelFunc(Number(params.value))
            },
            hide: true,
            enableRowGroup: true
          },
          { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', initialWidth: 200, enableRowGroup: true },
          { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargeDateOfDeparture'), field: 'bargeEtd', initialWidth: 200, hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          { headerName: this.$t('SeaExport.BargeVessel'), field: 'bargeVessel', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargeVoyage'), field: 'bargeVoyage', initialWidth: 200, hide: true, enableRowGroup: true },
          { headerName: this.$t('SeaExport.BargePortOfLoading'), field: 'bargePol', initialWidth: 200, hide: true, enableRowGroup: true },

          {
            headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
            },
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.isReceivable'), field: 'chargeReceivable', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
            },
            enableRowGroup: true
          },
          { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', initialWidth: 200 },
          { headerName: this.$t('Payment.moneyWriteOffStatus'), field: 'realClearingState',
            valueFormatter: (params) => {
              return ColumnUtils.realClearingStateLabFun(params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.realClearingStateLabFun(params.data.realClearingState)
            },
            initialWidth: 100
          },
          {
            headerName: this.$t('Billing.billingJob_chargesTotalAmount'), field: 'chargeAmount', initialWidth: 200,
            valueFormatter: (params) => {
              return !params.value ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2, true), 2)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.OperationDate'), field: 'jobCustomsDate', initialWidth: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'), field: 'truckingLoadingDate', initialWidth: 200, enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.ActualReturnTime'),
            field: 'destPortReturnTime',
            colId: 'destPortReturnTime',
            width: 150,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.ContainerDescription'),
            field: 'jobContainerDesc',
            valueFormatter: (params) => {
              return ColumnUtils.containerDescLabelFunc(params.value)
            },
            hide: true,
            initialWidth: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_CustomerLevel'),
            field: 'customerTypeId',
            cellRenderer: (params) => {
              return ColumnUtils.companyCustomerTypeLabelFunc(params.value)
            },
            filter: false,
            filterParams: {},
            hide: true,
            initialWidth: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.DeliveryCompletionDate'),
            field: 'deliveryCompletionDate',
            valueFormatter: (params) => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            initialWidth: 150,
            hide: true,
            enableRowGroup: true
          }, {
            headerName: this.$t('queryJob.route'),
            field: 'jobTransportLine',
            colId: 'jobTransportLine',
            valueFormatter: (params) => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            initialWidth: 150,
            hide: true
          }, {
            headerName: this.$t('Invoice.invoice_chargesRemarks'),
            field: 'chargeRemarks',
            initialWidth: 150,
            valueFormatter: (params) => {
              return ColumnUtils.chargeRemarksLabelFunc(params.value) || ''
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('Billing.billingCharge_invoiceNo'),
            field: 'chargeInvoiceNos',
            initialWidth: 150,
            valueGetter: (params) => {
              return ColumnUtils.chargeInvoiceNoLabelFunc(params.data.chargeInvoiceNos) || ''
            },
            enableRowGroup: true,
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.chargeInvoiceNoLabelFunc(params.data.chargeInvoiceNos)
            }
          }, {
            headerName: this.$t('queryJob.receivablesWriteOfStatus'),
            colId: 'verifyStateReceivable',
            field: 'verifyStateReceivable',
            width: 180,
            valueFormatter: (params) => {
              return ColumnUtils.writeOffStateLabFun(params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.writeOffStateLabFun(params.data.verifyStateReceivable)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
            field: 'userDefinedRoleId1',
            colId: 'userDefinedRoleId1',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
            field: 'userDefinedRoleId2',
            colId: 'userDefinedRoleId2',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader4'),
            field: 'userDefinedRoleId4',
            colId: 'userDefinedRoleId4',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_NominatedAgent'),
            field: 'jobDesignationAgent',
            colId: 'jobDesignationAgent',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3')
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.CargoActArrivalDatePacking'),
            field: 'jobActLoadingDate',
            colId: 'jobActLoadingDate',
            hide: true,
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
            field: 'jobDispatchingPlace',
            colId: 'jobDispatchingPlace',
            width: 120,
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
            field: 'actTakeTime',
            colId: 'actTakeTime',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('Partners.ParentCompany'), field: 'globalAccountUuid', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'uuid', params.value, 'auto_accountId') : ''
            },
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.SalesOfGoods'),
            colId: 'cargoSalesId',
            field: 'cargoSalesId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            width: 150,
            enableRowGroup: true
          }, {
            headerName: this.$t('SeaExport.BillExchangeAgent'),
            field: 'exChangeAgent',
            colId: 'exChangeAgent',
            hide: true,
            cellRenderer: (params) => {
              if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
                return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
              }
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
            },
            initialWidth: 200
          },
          { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true, enableRowGroup: true,
            cellRenderer: params => {
              if (params.value === '') return ''
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            filterParams: {},
            filterValueGetter: params => ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true, enableRowGroup: true,
            cellRenderer: params => {
              if (params.value === '') return ''
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
            },
            filterParams: {},
            filterValueGetter: params => ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
            field: 'companyCreateDate',
            colId: 'companyCreateDate',
            enableRowGroup: true,
            hide: true,
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.CostType'),
            colId: 'jobCostControlType',
            field: 'jobCostControlType',
            width: 120,
            valueFormatter: (params) => {
              const isZh = $store.getters.language === 'zh'
              return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
            },
            enableRowGroup: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_BusinessCreateDate'),
            field: 'jobDateCreated',
            initialWidth: 200,
            hide: true,
            enableRowGroup: true
          },
          {
            headerName: this.$t('Payment.amountNotWrittenOff'),
            field: 'chargeUnverifiedAmount',
            width: 200,
            hide: true,
            suppressColumnsToolPanel: this.showSalePriceHc,
            valueGetter: (params) => {
              const chargeAmount = params.data.chargeAmount || 0
              const chargeVerifiedAmount = params.data.chargeVerifiedAmount || 0
              if (chargeVerifiedAmount === 0) {
                return !chargeAmount ? '0.00' : formatNumberToThousands(chargeAmount, 2)
              }
              return formatNumberToThousands((chargeAmount - chargeVerifiedAmount), 2)
            },
            enableRowGroup: true
          }
        ]
      }

      const appendColumnDefs = [
        {
          headerName: this.$t('Billing.billing_reconciliationAmount'), field: 'chargeBillingAmount', initialWidth: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => ReconciliationUtils.checkEditable(params.data) && this.grid.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: this.showSalePriceHc,
          suppressColumnsToolPanel: this.showSalePriceHc,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Billing.billingCharge_difference'), field: 'chargeDiffAmount', initialWidth: 200,
          valueFormatter: (params) => {
            return !Number(params.value) ? '' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(Number(params.value), 2), 2)
          },
          hide: this.showSalePriceHc,
          suppressColumnsToolPanel: this.showSalePriceHc,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Billing.billingCharge_confirmState'), field: 'chargeConfirmState', colId: 'chargeConfirmState1', initialWidth: 100,
          cellRendererFramework: 'CargoGridOptCheckBox',
          onCellValueChanged: p => this.onCellChange(p),
          custom: {
            // 校验当前行可以编辑并且可确认，才允许操作勾选框
            editable: params => params.data && (ReconciliationUtils.checkEditableForReconciliation(params.data) || ReconciliationUtils.checkConfirmableForReconciliation(params.data)) && this.grid.isEdit,
            trueLabel: 1,
            falseLabel: 0,
            disabledFormatter: val => {
              return val ? this.$t('CargoMsg.Cargo_Confirmed') : this.$t('CargoMsg.Cargo_Unconfirmed')
            }
          },
          filterParams: {
            valueFormatter: (params) => {
              if (params.value === '1') {
                params.value = this.$t('Clearing.Confirmed')
              } else {
                params.value = this.$t('Clearing.Unconfirmed')
              }
              return params.value
            }
          }
        },
        {
          headerName: this.$t('Message.SettlementObjectAccountPeriod'),
          field: 'creditDateLimited',
          width: 100,
          hide: true,
          valueGetter: params => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementMethod'),
          field: 'creditDateType',
          width: 100,
          hide: true,
          valueGetter: params => {
            return ColumnUtils.creditDateTypeCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'fcAuditDate', width: 200,
          hide: true,
          valueGetter: (params) => {
            return ColumnUtils.dateLabelFunc(params.data.fcAuditDate)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100, enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_BillingWeightActual'),
          colId: 'chargeWeight',
          field: 'chargeWeight',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealAirExportChargeWeightActual(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealAirExportChargeWeightActual(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_BillingWeightContract'),
          colId: 'cWeight',
          field: 'cWeight',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealAirExportChargeWeightContract(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealAirExportChargeWeightContract(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_NumberOfItemsActual'),
          colId: 'quantityActual',
          field: 'quantityActual',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealAirImportNumberOfItemsActual(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealAirImportNumberOfItemsActual(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_NumberOfItemsContract'),
          colId: 'quantityContract',
          field: 'quantityContract',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealQuantityContract(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealQuantityContract(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_VolumeActual'),
          colId: 'cubageActual',
          field: 'cubageActual',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealAirImportVolumeActual(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealAirImportVolumeActual(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_VolumeContract'),
          colId: 'cubageContract',
          field: 'cubageContract',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealVolumeContract(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealVolumeContract(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_GrossWeightContract'),
          colId: 'weightContract',
          field: 'weightContract',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealWeightContract(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealWeightContract(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_GrossWeightActual'),
          colId: 'weightActual',
          field: 'weightActual',
          width: 180,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.dealAirImportWeightActual(params.data)
          },
          valueFormatter: (params) => {
            return ColumnUtils.dealAirImportWeightActual(params.data)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Message.SettlementObjectAccountCredit'),
          field: 'credit',
          width: 100,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.creditCommonLabelFunc(params.data)
          }
        }
      ]
      if (this.openBatchUpdateConfirmSerialNumber && !this.isJobBillType) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ChargeConfirmSerialNumber'),
          colId: 'chargeConfirmSerialNumber',
          field: 'chargeConfirmSerialNumber',
          initialWidth: 200,
          hide: true
        })
      }
      if (this.useOrderCenterMode) {
        columnDefs = [
          ...columnDefs,
          {
            headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
            colId: 'cooperatebranch',
            field: 'cooperatebranch',
            width: 160, minWidth: 160,
            hide: !this.useOrderCenterMode
          }, {
            headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
            colId: 'cooperateBusinessType',
            field: 'cooperateBusinessType',
            width: 200, minWidth: 200,
            hide: !this.useOrderCenterMode
          }
        ]
      }
      return columnDefs.concat(appendColumnDefs)
    },
    isCheckBox() {
      return this.grid.isEdit ? 'el-checkbox' : 'span'
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    // $route: {
    //   immediate: true,
    //   deep: true,
    //   handler(val, oldVal) {
    //     if (oldVal.name === 'AutomaticReconciliation' && val.name === 'BillingNative' && this.$route.params.refresh) {
    //       this.toAdvQueryList(this.searchConditions.snapshotConditions)
    //     }
    //   }
    // },
    billType(newVal, oldVal) {
      // 费用、业务切换后，需要显示各自的数据集合
      this.appendQuery = false
      if (newVal === 'charge') {
        this.rowData = this.rowDataCharge
        this.searchConditionsJob = { ...this.searchConditions }
        this.searchConditions = { ...this.searchConditionsCharge }
      } else {
        this.rowData = this.rowDataJob
        this.searchConditionsCharge = { ...this.searchConditions }
        this.searchConditions = { ...this.searchConditionsJob }
      }
      this.totalConfig = [
        { ...this.$refs.chargeCurrencyTotalGroup1.chargeCurrencyTotalGroupData, label: '' },
        { ...this.$refs.chargeCurrencyTotalGroup2.chargeCurrencyTotalGroupData, label: this.$t('CargoMsg.Cargo_ReconciliationAmount') },
        { ...this.$refs.chargeCurrencyTotalGroup3.chargeCurrencyTotalGroupData, label: this.$t('CargoMsg.Cargo_Difference') }
      ]
      this.totalAmountToCurrency.dataProvider = []
      this.$nextTick(() => {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.selectionChanged()
      })
    },
    rowData() {
      this.totalConfig = [
        { ...this.$refs.chargeCurrencyTotalGroup1.chargeCurrencyTotalGroupData, label: '' },
        { ...this.$refs.chargeCurrencyTotalGroup2.chargeCurrencyTotalGroupData, label: this.$t('CargoMsg.Cargo_ReconciliationAmount') },
        { ...this.$refs.chargeCurrencyTotalGroup3.chargeCurrencyTotalGroupData, label: this.$t('CargoMsg.Cargo_Difference') }
      ]
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await this.initCustomSearchItems()
      }
    }
  },
  async created() {
    // 显示销售单价hc权限：复数权限接口对管理员也返回真实配置，配置了该权限才隐藏
    // 使用 await 确保权限在表格初始化前赋值完成
    const salePriceHcRes = await getUserPrivileges()
    const list = (salePriceHcRes && salePriceHcRes.data) || []
    this.showSalePriceHc = list.some(p => p.category === 'role' && p.shape === 'show_filed' && p.point === 'price')
    await this.initConfig()
    // 判断权限
    const arCharges = this.$checkPermission(['filter_ACTBilling_arCharges'])
    const apCharges = this.$checkPermission(['filter_ACTBilling_apCharges'])
    const allCharges = this.$checkPermission(['filter_ACTBilling_allCharges'])
    const allRegionalCharges = this.$checkPermission(['filter_ACTBilling_allRegionalCharges'])
    const overseaCharges = this.$checkPermission(['filter_ACTBilling_overseaCharges'])
    const localCharges = this.$checkPermission(['filter_ACTBilling_localCharges'])

    this.role.confirmCharges = this.$checkPermission(['button_ACTBilling_confirmCharges'])
    this.role.createInvoiceFromCharges = this.$checkPermission(['button_ACTBilling_createInvoiceFromCharges']) // 开票权限
    this.role.createInvoiceFromApCharges = this.$checkPermission(['button_ACTBilling_createInvoiceFromApCharges']) // 收票权限
    this.role.writeoffCharges = this.$checkPermission(['button_ACTBilling_writeoffCharges'])
    this.role.payauthFromCharges = this.$checkPermission(['button_ACTBilling_payauthFromCharges'])
    this.role.auditCharge = this.$checkPermission(['button_ACTBilling_auditCharge'])
    this.role.cancelAuditCharge = this.$checkPermission(['button_ACTBilling_cancelAuditCharge'])
    this.role.batchUpdateConfirmSerialNumber = this.$checkPermission(['button_ACTBilling_batchUpdateConfirmSerialNumber'])
    this.role.batchUpload = this.$checkPermission(['button_ACTBilling_reconciliationBatchUpload']) // 批量上传按钮
    this.chargeEditPrivilege = buildChargeEditPrivilege(this)
    this.openBatchUpdateConfirmSerialNumber = Number(cache.config.get('openBatchUpdateConfirmSerialNumber')) === 1
    const defaultSearchConditions = this.defaultSearchConditions
    if (arCharges) {
      defaultSearchConditions.isAr = 1
    } else if (!arCharges && apCharges) {
      defaultSearchConditions.isAr = 0
    } else if (!arCharges && !apCharges && allCharges) {
      defaultSearchConditions.isAr = -1
    }
    if (localCharges) {
      defaultSearchConditions.oversea = 0
    } else if (!localCharges && overseaCharges) {
      defaultSearchConditions.oversea = 1
    } else if (!overseaCharges && !localCharges && allRegionalCharges) {
      defaultSearchConditions.oversea = -1
    }
    this.chargeAuditFlow = Number(cache.config.get('chargeAuditFlow')) === 1
    await ensureExecuteSuccess(() => this.jobDefaultSearchItems.length > 0 && this.chargeDefaultSearchItems.length > 0)
    // 加载银行账户列表（销账银行下拉数据源 + 列表渲染使用）：必须先于 initCustomSearchItems，否则下拉 dataProvider 固化为空
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
      return res.data
    })
    await this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  async beforeMount() {
    const cxt = this
    this.documentManage.set('toFinanceChargeTab', () => {
      cxt.toFinanceChargeTab()
    })
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      onSelectionChanged: this.selectionChanged,
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridCommonInputEditor,
        CargoAgGridCommonTextareaEditor
      },
      autoGroupColumnDef: {
        headerName: this.$t('Message.DataGroup'),
        field: 'autoColumn',
        minWidth: 220,
        comparator: (a, b) => {
          if (typeof a === 'string' && typeof b === 'string') {
            if (a && b) {
              const newA = a.replaceAll(',', '')
              const newB = b.replaceAll(',', '')
              if (isNumber2(newA) && isNumber2(newB)) {
                a = Number(newA)
                b = Number(newB)
              }
            }
            if (a && b && typeof a === 'number' && typeof b === 'number') {
              if (!isNaN(a) && !isNaN(b)) {
                return a - b
              }
            }
            for (let i = 0; i < a.length && i < b.length; ++i) {
              const aCode = a.charCodeAt(i)
              const bCode = b.charCodeAt(i)
              const diff = aCode >= 256 && bCode >= 256 ? a[i].localeCompare(b[i], 'zh') : aCode - bCode
              if (diff !== 0) {
                return diff
              }
            }
            return a.length - b.length
          }
          if (a === b) {
            return 0
          } else if (a < b) {
            return -1
          } else {
            return 1
          }
        }
      }
    }
  },
  mounted() {
    this.scrollCallback()
    this.monitorIsArChange()
    document.querySelector('.main-content').addEventListener('scroll', this.scrollCallback)
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    monitorIsArChange() {
      // 使用深度监听来监控嵌套属性
      this.$watch(
        () => this.$refs.chargeExtCond?.ownConditions?.isAr,
        (newVal, oldVal) => {
          this.chargeIsAr = newVal
        },
        {
          deep: true,
          immediate: true
        }
      )
      this.$watch(
        () => this.$refs.jobExtCond?.ownConditions?.isAr,
        (newVal, oldVal) => {
          this.jobIsAr = newVal
        },
        {
          deep: true,
          immediate: true
        }
      )
    },
    // 跳转导入模板方案
    async fetchStaticTitleList() {
      try {
        const officeId = this.$store.getters.currentOfficeId
        const res = await getInvoiceTitlesByOffice({ officeId })
        return res && Array.isArray(res.data) ? res.data : []
      } catch (e) {
        return []
      }
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      // 销货单位数据源（复用【开票»发票查询】：getInvoiceTitlesByOffice，按当前 office、实时不缓存）
      const sellTitleList = await this.fetchStaticTitleList()
      // 账单业务状态配置项
      const billingJobStates = await LoadDefaultQueryParam.getConfigQueryParam('BillingJobState', SystemConstants.JOB_STATES)
      if (billingJobStates && billingJobStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_businessStatus'
        searchField.itemName = 'job.JOB_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = billingJobStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 账单费用状态配置项
      const billingChargeStates = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeState', ChargeConstants.CHARGE_STATES)
      if (billingChargeStates && billingChargeStates.length > 0) {
        if (!this.chargeAuditFlow) {
          for (let i = 0; i < billingChargeStates.length; i++) {
            const chargeState = billingChargeStates[i]
            if (chargeState.code === ChargeConstants.STATE_REJECT.code) {
              billingChargeStates.splice(i, 1)
              break
            }
          }
        }
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_feeStatus'
        searchField.itemName = 'charge.CHARGE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = billingChargeStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 账单费用确认状态配置项
      const billingChargeConfirmStates = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeConfirmState', ChargeConstants.CONFIRM_STATES)
      if (billingChargeConfirmStates && billingChargeConfirmStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_confirmStatus'
        searchField.itemName = 'charge.CONFIRM_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = billingChargeConfirmStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      const billingHasPaidOff = cache.config.get('BillingHasPaidOff')
      if (billingHasPaidOff) {
        const value = LoadDefaultQueryParam.getCheckBoxValue(billingHasPaidOff)
        if (value != null) {
          const searchField = new AdvancedSearchField()
          searchField.multiple = 0
          searchField.defaultValue = value
          searchField.itemLabel = 'Payment.wroteOffOrNot'
          searchField.itemName = 'charge.PAID_OFF'
          searchField.fieldType = 'FIELD_CHECKBOX'
          searchField.lock = true
          searchField.defaultSelected = 1
          searchField.selected = 1
          searchField.action = 2
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      const billingHasBilling = cache.config.get('BillingHasBilling')
      if (billingHasBilling) {
        const value = LoadDefaultQueryParam.getCheckBoxValue(billingHasBilling)
        if (value || value === false) {
          const searchField = new AdvancedSearchField()
          searchField.multiple = 0
          searchField.defaultValue = value
          searchField.itemLabel = 'Payment.generatedBillsOrNot'
          searchField.itemName = 'charge.BILLING_UUID'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.lock = true
          searchField.defaultSelected = 1
          searchField.selected = 1
          searchField.action = 2
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      const billingHasBillPayment = cache.config.get('BillingHasBillPayment')
      if (billingHasBillPayment) {
        const value = LoadDefaultQueryParam.getCheckBoxValue(billingHasBillPayment)
        if (value || value === false) {
          const searchField = new AdvancedSearchField()
          searchField.multiple = 0
          searchField.defaultValue = value
          searchField.itemLabel = 'Payment.appliedForPaymentOrNot'
          searchField.itemName = 'charge.BILL_PAYMENT_UUID'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.lock = true
          searchField.defaultSelected = 1
          searchField.selected = 1
          searchField.action = 2
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 费用批次号
      if (this.openBatchUpdateConfirmSerialNumber && !this.isJobBillType) {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.multiple = 0
        searchField.defaultValue = ''
        searchField.itemLabel = 'CargoMsg.Cargo_ChargeConfirmSerialNumber'
        searchField.itemName = 'charge.CONFIRM_SERIAL_NUMBER'
        searchField.fieldType = 'FIELD_TEXT2'
        searchField.lock = false
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.action = 0
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 费用名称
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'chargeItem'
      searchField.itemLabel = 'Payment.chargeItem'
      searchField.itemName = 'charge.CHARGEITEMID'
      searchField.fieldType = 'FIELD_CHARGE'
      searchField.defaultSelected = 1
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 整拼类型
      searchField = new AdvancedSearchField()
      searchField.itemType = 'containerLoadTypeCascader'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST_ALL_LOB'
      searchField.itemCondition = [OPERATOR_IN]
      searchField.defaultConditionVal = 'IN'
      searchField.itemName = 'containerLoadTypeForAll'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessModel'
      searchField.defaultValue = []
      searchField.action = AdvancedSearchField.ADD_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      // 海外跟单（UI 自定义岗位4）：保留 IN/NOT IN 的多选语义，界面显示等于/不等于
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.multiple = 1
      searchField.subType = {
        category: 'role',
        shape: 'userDefinedRole4'
      }
      searchField.itemCondition = [
        { ...OPERATOR_IN, chineseName: '等于', englishName: 'Equal' },
        { ...OPERATOR_NOT_IN, chineseName: '不等于', englishName: 'Unequal' }
      ]
      searchField.defaultConditionVal = OPERATOR_IN.code
      searchField.itemName = 'job.user_defined_role_id_4'
      searchField.itemLabel = 'CargoMsg.Cargo_UserDefinedRoleHeader4'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // 销货单位（双面板通用：加入 defaultSearchFields，job/charge 均生效；数据源复用【开票»发票查询】）
      const sellTitleField = new AdvancedSearchField()
      sellTitleField.itemType = 'advanceSelect'
      sellTitleField.dataCacheKey = 'static_data_InvoiceTitle'
      sellTitleField.multiple = 1
      sellTitleField.action = 2
      sellTitleField.fieldType = 'FIELD_DROP_DOWN_LIST'
      sellTitleField.itemValue = []
      sellTitleField.defaultValue = []
      sellTitleField.itemLabel = 'Invoice.closeAccountCompany'
      sellTitleField.itemName = 'invoice.SELL_TITLE'
      sellTitleField.headers = [this.$t('Invoice.invoice_invoiceHeader')]
      sellTitleField.fields = ['invoiceTitle']
      sellTitleField.tagName = 'invoiceTitle'
      sellTitleField.tagValue = 'invoiceTitle'
      sellTitleField.itemCondition = FIELD_OPERATOR_MAP['multiDropDownList']
      sellTitleField.defaultConditionVal = OPERATOR_IN.code
      sellTitleField.dataProvider = sellTitleList
      sellTitleField.lock = false
      sellTitleField.defaultSelected = 1
      sellTitleField.selected = 0
      defaultSearchFields.push(sellTitleField.formatObj2Json())

      this.jobCustomSearchItems = defaultSearchFields

      const chargeDefaultSearchFields = [...defaultSearchFields]
      // 到期日计算状态
      searchField = new AdvancedSearchField()
      searchField.action = 0
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.DueDateDirty'
      searchField.itemName = '_dueDateCalculateState'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = [
        { code: 0, chineseName: this.$t('Billing.NotCalculated'), englishName: this.$t('Billing.NotCalculated') },
        { code: 1, chineseName: this.$t('Billing.InCalculation'), englishName: this.$t('Billing.InCalculation') },
        { code: 2, chineseName: this.$t('Billing.Calculated'), englishName: this.$t('Billing.Calculated') }
      ]
      chargeDefaultSearchFields.push(searchField.formatObj2Json())
      // 我方银行
      const dataProvider = []
      if (this.bankAccounts) {
        for (const bankAccount of this.bankAccounts) {
          const chineseName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
          const englishName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankEnglishName
          // CARGO-15701，销账查询页签，我方银行的查询条件:币种+账号
          dataProvider.push({
            code: (bankAccount.accountNo + '' + bankAccount.currency),
            chineseName: chineseName,
            englishName: englishName
          })
        }
      }
      searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_COMPANY'
      searchField.multiple = 1
      searchField.itemLabel = 'CargoMsg.Cargo_WriteOffBank'
      searchField.itemName = 'actualAmount.OURBANK'
      searchField.itemValue = []
      searchField.defaultValue = []
      searchField.itemCondition = FIELD_OPERATOR_MAP['multiDropDownList']
      searchField.defaultConditionVal = OPERATOR_IN.code
      searchField.fields = ['chineseName']
      searchField.tagName = 'chineseName'
      searchField.tagValue = 'code'
      searchField.lock = false
      searchField.dataProvider = dataProvider
      searchField.action = 2
      searchField.defaultSelected = 1
      searchField.selected = 0
      // 选项文本为 [账号][币种]银行名，键入过滤须开 global（包含匹配），对齐 writeOffSearch 我方银行
      searchField.filterType = 'global'
      chargeDefaultSearchFields.push(searchField.formatObj2Json())

      if (!this.isJobBillType) {
        // 结算部门
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Payment.settleDepartmentPrefix'
        searchField.itemName = 'charge.SETTLE_DEPARTMENT_PREFIX'
        searchField.itemValue = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        const departments = this.getDepartmentsByOfficeUuid(this.$store.getters.currentOfficeId)
        searchField.dataProvider = departments
        chargeDefaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.hmToFinanceApi) {
        // 费用同步云平台状态
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'financialSettlementPushRecord.SEND_STATUS'
        searchField.itemLabel = 'Clearing.CostSyncColudStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.HM_YONGYOU_SYNC_STATUS
        searchField.action = AdvancedSearchField.ADD_ACTION
        chargeDefaultSearchFields.push(searchField.formatObj2Json())
      } else {
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'financialSettlementPushRecord.SEND_STATUS'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        chargeDefaultSearchFields.push(searchField.formatObj2Json())
      }
      const isZh = $store.getters.language === 'zh'
      if (!isZh) {
        // 费用语言配置
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'chargeItem'
        searchField.multiple = 0
        searchField.defaultValue = ''
        searchField.itemLabel = 'Payment.chargeItem'
        searchField.itemName = 'charge.CHARGEITEMID'
        searchField.fieldType = 'FIELD_CHARGE'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dataProvider = chargeItemLanguage()
        chargeDefaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.jobDefaultSearchItems, defaultSearchFields)
        JobUtils.configSearchItemsChildOffice(this.chargeDefaultSearchItems, chargeDefaultSearchFields)
      }
      this.chargeCustomSearchItems = chargeDefaultSearchFields
    },
    // 跳转导入模板方案
    jump() {
      this.importFormDialog = false
      this.$router.push({
        name: 'ImportingTemplate'
      })
    },
    // 跳转自动对账
    commandHandle() {
      switch (this.command1) {
        case this.$t('CargoMsg.Cargo_StartReconciliation'):
          this.startReconciliationBill()
          break
        case this.$t('CargoMsg.AutomaticReconciliation'):
          // eslint-disable-next-line no-case-declarations
          const newConditions = JSON.parse(JSON.stringify(this.batchGenerateBillingDialog.conditions))
          // eslint-disable-next-line no-case-declarations
          const dialogIsShow = newConditions.find((item) => {
            if (item.operator !== '!=' && item.fieldName === 'charge.ACCOUNT_ID') {
              return item
            }
          })
          if (!dialogIsShow) {
            this.$message.warning(this.$t('Clearing.PleaseSettlementUnitBeforeImporting'))
            return
          }
          if (this.rowData.length === 0) {
            this.$message.warning(this.$t('Clearing.NoFoundNoNeedReconcile'))
            return
          }
          this.schemeList()
          BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_1')
          this.dialogTitle = this.$t('Clearing.SelectImportTemplateSolution')
          this.importFormDialog = true
          this.solutionsValue = ''
          break
        case this.$t('CargoMsg.CheckHistory'):
          this.$router.push({
            name: 'AutomaticReconciliation',
            params: {
              name: 'automaticReconciliationHistory'
            }
          })
          break
      }
    },
    // 导入方案下拉数据
    async schemeList() {
      this.loading = getLoading()
      const data = {
        paging: false,
        tenantId: this.$store.getters.tenantId
      }
      const res = await queryTemplateList(data).finally(() => {
        this.loading.close()
      })
      if (res.ok && res.data.list.length > 0) {
        this.solutionsNameList = res.data.list
        this.plan = this.$t('Clearing.PleaseSelectASolution')
      } else {
        this.solutionsNameList = []
        this.plan = this.$t('Clearing.PleaseBasicDataImportSolution')
      }
    },
    // 导入接口
    async importExcelEventHandler(item) {
      if (!this.solutionsValue) {
        this.$message.warning(this.$t('Clearing.PleaseBasicDataImportSolution'))
        return false
      }
      this.loading = getLoading()
      const data = {
        file: item.file,
        templateUuid: this.solutionsValue,
        queryChargeListRequest: JSON.stringify(this.filterParameters)
      }
      const res = await importReconciliationBill(data).finally(() => {
        this.loading.close()
      })
      if (res.ok && res.data) {
        if (res.data.rowNum === res.data.successNum) {
          setTimeout(() => {
            this.$router.push({
              name: 'AutomaticReconciliation',
              params: {
                redisKey: res.data.redisKey,
                name: 'automaticReconciliation',
                successNum: res.data.successNum
              }
            })
            this.importFormDialog = false
          }, 10)
        } else {
          this.dialogTitle = this.$t('Clearing.Prompt')
          if (!res.data.successNum) {
            this.successOrFailure.succeed = 0
          } else {
            this.successOrFailure.succeed = res.data.successNum
          }
          this.successOrFailure.failure = res.data.rowNum - res.data.successNum
          this.storageURL = await cache.config.get('StorageURL')
          this.importFailure = `${URL.common.findByFileId}/${res.data.resultDocumentId}?sessionId=${this.$store.getters.token}`
        }
      }
    },
    async determineScheme() {
      this.beforeUploadUsage()
    },
    // 下载失败的文件
    download() {
      window.open(this.importFailure, '_blank')
      this.importFormDialog = false
    },
    // 导入文件格式不对时给提醒
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('Clearing.ImportErrorPleaseReImport'))
      }
      return extension || extension2
    },
    // 为选择方案时的button点击事件，主要为提醒
    theImport() {
      if (!this.solutionsValue) {
        this.$message.warning(this.$t('Clearing.PleaseSelectATemplate'))
        return false
      }
    },
    // 初始化一些 config表的配置信息
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.diffChargeByBillingAmountPattern = cache.config.get('DiffChargeByBillingAmountPattern')
      this.showBatchGenerateBillingBtn = Number(cache.config.get('showBatchGenerateBillingBtn')) === 1
      this.chargeSubmitDirect = Number(cache.config.get('ChargeSubmitDirect')) === 1
      this.submitChargeRole = this.$checkPermission(['button_ACTBilling_submitCharge'])
      this.cancelSubmitChargeRole = this.$checkPermission(['button_ACTBilling_unsubmitCharge'])
      this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      await this.loadInstructionButtons()
    },
    onCellChange(params) {
      const newParams = { ...params, value: params.value || params.newValue }
      let flag = false
      const v = params.field || params.colDef.field
      switch (v) {
        case 'chargeConfirmState':
          flag = this.onChargeConfirmStateCellChange(newParams)
          break
        case 'chargeBillingAmount':
          flag = this.onChargeBillingAmountCellChange(newParams)
          break
        case 'chargeConfirmRemarks':
          flag = this.onChargeConfirmRemarkCellChange(newParams)
          break
        case 'reviewRemarks':
          flag = this.onReviewRemarkCellChange(newParams)
          break
      }
      // 手动重新渲染单元格
      if (flag) {
        // this.gridOptions.api.setColumnDefs(this.dynamicColumnDefs)
        this.totalAmountToCurrency.dataProvider = []
        this.$nextTick(() => {
          this.totalAmountToCurrency.dataProvider = this.rowData
          this.selectionChanged()
        })
      }
    },
    // 监听费用确认状态发生变化
    onChargeConfirmStateCellChange(params) {
      const confirmState = params.value ? 1 : 0
      const data = params.data
      data['chargeConfirmState'] = confirmState
      data['dirty'] = true
      if (data['entity'] === 'job') {
        if (data['chargeConfirmState'] === 1) {
          data['chargeBillingAmount'] = data['chargeAmount']
          data['chargeDiffAmount'] = 0
        } else {
          data['chargeBillingAmount'] = 0
          data['chargeDiffAmount'] = data['chargeAmount']
        }
        for (const charge of data['charges']) {
          if (data['chargeConfirmState'] === 1) {
            charge['chargeBillingAmount'] = charge['chargeAmount']
            charge['chargeDiffAmount'] = 0
            charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
            charge['chargeConfirmUser'] = this.$store.getters.userInfo.userId
          } else {
            charge['chargeBillingAmount'] = 0
            charge['chargeDiffAmount'] = charge['chargeAmount']
            charge['chargeConfirmDate'] = null
            charge['chargeConfirmUser'] = 0
          }
          charge['chargeConfirmState'] = data['chargeConfirmState']
          charge['dirty'] = true
        }
        this.gridOptions.api.applyTransactionAsync({ update: [data] })
      } else {
        if (confirmState === 1) {
          data['chargeBillingAmount'] = data['chargeAmount']
          data['chargeDiffAmount'] = 0
          data['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          data['chargeConfirmUser'] = this.$store.getters.userInfo.userId
        } else {
          data['chargeConfirmDate'] = null
          data['chargeConfirmUser'] = 0
          data['chargeBillingAmount'] = 0
          data['chargeDiffAmount'] = data['chargeAmount']
        }
        this.gridOptions.api.applyTransactionAsync({ update: [data] })
      }// 重新渲染修改的行
      return true
    },
    // 监听对账金额发生变化
    async onChargeBillingAmountCellChange(params) {
      const data = params.data
      let billingAmount = params.value
      if (isNaN(billingAmount)) {
        data['chargeBillingAmount'] = 0.0
        return true
      }
      // billingAmount = NumberUtils.roundHalfUp(billingAmount, 2)
      billingAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(billingAmount, data['chargeCurrency']), 2)
      if (data['entity'] === 'job') {
        data['chargeBillingAmount'] = Number(billingAmount)
        ReconciliationUtils.shareJobBillingAmount(data)
        data['chargeDiffAmount'] = await ReconciliationUtils.sumChargeDiffAmount(data)
        data['dirty'] = true
        for (const charge of data['charges']) {
          charge['dirty'] = true
        }
        this.rowData = [...this.rowData]
      } else {
        const amount = params.data['chargeAmount']// 原费用金额
        billingAmount = Number(billingAmount)
        const chargeAmount = Math.abs(amount)// 取绝对值后的费用金额
        const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
        if (Number(this.diffChargeByBillingAmountPattern) === 1) {
          if ((chargeAmount < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TRAYEINR'))
            data['chargeBillingAmount'] = 0
            data['chargeDiffAmount'] = amount
            return false
          } else {
            if (amount > 0) {
              data['chargeDiffAmount'] = NumberUtils.roundHalfUp(amount - billingAmount, 2)
            } else {
              data['chargeDiffAmount'] = NumberUtils.roundHalfUp(-(chargeAmount - billingAmountNew), 2)
            }
            data['dirty'] = true
          }
        } else {
          data['chargeDiffAmount'] = NumberUtils.roundHalfUp(data['chargeAmount'] - billingAmount, 2)
          data['dirty'] = true
        }
        data['chargeBillingAmount'] = Number(billingAmount)
        const index = this.rowData.findIndex(row => {
          if (row.uuid && data.uuid) { // 真实存在的费用
            return row.uuid === data.uuid
          } else if (row.chargeUid && data.chargeUid) { // 新增的费用
            return row.chargeUid === data.chargeUid
          }
        })
        if (index > -1) {
          const rowData = this.rowData
          rowData[index] = data
          this.rowData = [...rowData]
        }
      }
      return true
    },
    // 监听确认备注发生变化
    onChargeConfirmRemarkCellChange(params) {
      const confirmRemark = params.value
      const data = params.data
      data['chargeConfirmRemarks'] = confirmRemark
      data['dirty'] = true
      return true
    },
    onReviewRemarkCellChange(params) {
      const confirmRemark = params.value
      const data = params.data
      data['reviewRemarks'] = confirmRemark
      return true
    },
    fetchData({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      if (simpleTriggerMode) {
        this.appendQuery = false // 关闭追加查询
        const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
        finallyConditions.push(option.formatObj2Json())
      } else {
        // 高级查询条件组装
        const advConditions = conditions
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(advConditions)
        finallyConditions.push(...advConditions)
      }
      this.searchConditions.snapshotConditions = finallyConditions
      this.showLoading = true
      this.toAdvQueryList(finallyConditions)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.showLoading = true
      this.clearSelectionOnLoad = true
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    toFinanceChargeTab(value) {
      if (value && this.currentOptStatus !== this.optStatusDefs.checking) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    // 列表查询
    toAdvQueryList(conditions) {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      // 判断是否权限，如果没有权限，则禁止进行数据查询
      const arCharges = this.$checkPermission(['filter_ACTBilling_arCharges'])
      const apCharges = this.$checkPermission(['filter_ACTBilling_apCharges'])
      const allCharges = this.$checkPermission(['filter_ACTBilling_allCharges'])
      const overseaCharges = this.$checkPermission(['filter_ACTBilling_overseaCharges'])
      const localCharges = this.$checkPermission(['filter_ACTBilling_localCharges'])
      const allRegionalCharges = this.$checkPermission(['filter_ACTBilling_allRegionalCharges'])
      if (!arCharges && !apCharges && !allCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoPaymentMethodPermissionOfReconciliation'))
        return
      }
      if (!allRegionalCharges && !overseaCharges && !localCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFeeTypePermissionOfReconciliation'))
        return
      }
      const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
      let inputDate = ''
      if (defaultSearchConditions.businessDate.length === 2 && defaultSearchConditions.businessDate[0] && defaultSearchConditions.businessDate[1]) {
        inputDate = 'start=' + defaultSearchConditions.businessDate[0] + ' 00:00:00' + ',end=' + defaultSearchConditions.businessDate[1] + ' 23:59:59'
      } else if (defaultSearchConditions.businessDate.length === 2 && defaultSearchConditions.businessDate[0] && !defaultSearchConditions.businessDate[1]) {
        inputDate = 'start=' + defaultSearchConditions.businessDate[0] + ' 00:00:00'
      } else if (defaultSearchConditions.businessDate.length === 2 && !defaultSearchConditions.businessDate[0] && defaultSearchConditions.businessDate[1]) {
        inputDate = 'end=' + defaultSearchConditions.businessDate[1] + ' 23:59:59'
      }
      if (inputDate) {
        let filedName = ''
        if (!this.isJobBillType) { // 按费用查询
          filedName = 'charge.BUSINESS_DATE'
        } else { // 按业务查询
          filedName = 'job.BUSINESS_DATE'
        }
        const condition = new AdvancedSearchOption(null, filedName, inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否查询受控费用
      if (!this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          conditions.push(option.formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('actualAmount.OURBANK', conditions)) {
        const offsetStateOption = AdvancedSearchOption.getOption('actualAmount.OURBANK', conditions)
        // if (offsetStateOption.selectedItem != null) {
        //   offsetStateOption.value = offsetStateOption.selectedItem.currency + '||' + offsetStateOption.value
        // }
        if (offsetStateOption && offsetStateOption.value && offsetStateOption.value.length > 0) {
          const bankAccounts = this.bankAccounts.filter(p => offsetStateOption.value.includes(p.accountNo + '' + p.currency))
          if (bankAccounts && bankAccounts.length > 0) {
            const arr = []
            for (const bankAccount of bankAccounts) {
              arr.push(bankAccount.currency + '||' + bankAccount.accountNo)
            }
            AdvancedSearchOption.removeOption('actualAmount.OURBANK', conditions)
            offsetStateOption.value = arr
            conditions.push(offsetStateOption)
          }
        }
      }
      if (!this.isJobBillType) { // 按费用查询
        this.toAdvQueryChargeList(conditions)
      } else { // 按业务查询
        this.toAdvQueryJobList(conditions)
      }
    },
    // 按业务查询
    async toAdvQueryJobList(conditions) {
      const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
      defaultSearchConditions.advance = 0
      if (defaultSearchConditions.oversea > -1) {
        const condition = new AdvancedSearchOption(null, 'charge.OVERSEA', defaultSearchConditions.oversea === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (defaultSearchConditions.advance !== -1 && !AdvancedSearchOption.hasField('charge.ADVANCE', conditions)) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', defaultSearchConditions.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam('BillingJobState', SystemConstants.JOB_STATES)
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(billingJobState)
          const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeState', ChargeConstants.CHARGE_STATES)
        if (billingChargeState) {
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeState)
          const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeConfirmState', ChargeConstants.CONFIRM_STATES)
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeConfirmState)
          const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (defaultSearchConditions.hasBillPayment !== -1) {
        const operator = defaultSearchConditions.hasBillPayment === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', defaultSearchConditions.exceptKeys, operator)
        conditions.push(condition.formatObj2Json())
      }
      if (defaultSearchConditions.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', defaultSearchConditions.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (defaultSearchConditions.shared !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.SHARED', defaultSearchConditions.shared === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      const condition = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
      // 内结
      if (defaultSearchConditions.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }

      if (this.showLoading) {
        this.loading = getLoading()
      }
      const groups = []
      groups.push('job.UUID')
      groups.push('charge.CURRENCY')
      groups.push('charge.ACCOUNT_ID')
      groups.push('charge.CONFIRM_STATE')
      groups.push('charge.ACCOUNT_RECEIVABLE')

      const requires = [...this.requires]
      if (this.showFba) { requires.push('fba') }
      if (this.hmToFinanceApi) {
        requires.push('hmToFinanceApi')
      }
      const requestBody = {
        conditions,
        requires,
        groups: groups,
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        'requestSource': 'Reconciliation'
      }
      requestBody.appendQuery = this.appendQuery
      this.filterParameters = requestBody
      await getReconciliationJobList(requestBody).then(res => {
        let results = res.data.list
        if (results && results.length > 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.rowDataJob, results, this.appendQuery)
          }
          if (this.updateRows) {
            const { rowsToDisplay } = this.gridOptions.api.getModel()
            rowsToDisplay.forEach(node => {
              if (!node.data) {
                return
              }
              node.setSelected(false)
              const { data } = node
              const newData = results.find(row => {
                if (this.billType === 'job') {
                  return row.chargeUuids === data.chargeUuids
                } else {
                  return row.uuid === data.uuid
                }
              }
              )
              if (newData) {
                node.setData(newData)
              } else {
                this.gridOptions.api.updateRowData({ remove: [node.data] })
              }
            })
            results.forEach(item => {
              const newData = rowsToDisplay.find(row => {
                if (!row.data) {
                  return false
                }
                if (this.billType === 'job') {
                  return row.data.chargeUuids === item.chargeUuids
                } else {
                  return row.data.uuid === item.uuid
                }
              })
              if (!newData) {
                this.gridOptions.api.updateRowData({ add: [item] })
              }
            })
            this.updateRows = false
          } else {
            this.rowData = results
          }
          this.rowDataJob = results
          if (defaultSearchConditions.isAr === -1) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_AllB')
          } else if (defaultSearchConditions.isAr === 0) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_DuesB')
          } else if (defaultSearchConditions.isAr === 1) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_ReceivableB')
          }
          this.totalAmountToCurrency.dataProvider = results
        } else {
          if (this.appendQuery) return
          this.rowData = []
          this.rowDataJob = []
          this.totalAmountToCurrency.labelText = ''
          this.totalAmountToCurrency.dataProvider = []
        }
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        this.$nextTick(() => {
          this.afterDataLoaded()
        })
      }).finally(() => {
        if (this.showLoading) {
          this.loading.close()
        }
      })
    },
    // 按费用查询
    async toAdvQueryChargeList(conditions) {
      const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
      // 结算类型中的"月结"是按照大于1来判断的，不能用等于
      for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i]
        if (condition.fieldName === 'creditInfo.CREDIT_DATE_LIMITED' && condition.value === 1) {
          condition.operator = OperatorConstants.OPERATOR_GREATER.code
          break
        }
      }
      // 应收/应付
      if (defaultSearchConditions.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', defaultSearchConditions.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否垫付
      if (defaultSearchConditions.advance !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', defaultSearchConditions.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      // 国内/国外
      if (defaultSearchConditions.oversea > -1) {
        const condition = new AdvancedSearchOption(null, 'charge.OVERSEA', defaultSearchConditions.oversea === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否开票
      if (defaultSearchConditions.hasInvoice !== -1) {
        const operator = defaultSearchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }
      // 红冲状态
      const condition = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
      // 是否关联差异对冲费用
      if (defaultSearchConditions.hasDiffCharge !== -1) {
        const operator = defaultSearchConditions.hasDiffCharge === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        conditions.addItem(new AdvancedSearchOption(null, 'charge.DIFF_CHARGE_UUID', null, operator))
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam('BillingJobState', SystemConstants.JOB_STATES)
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(billingJobState)
          const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用状态
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeState', ChargeConstants.CHARGE_STATES)
        if (billingChargeState) {
          const chargeAuditFlow = Number(cache.config.get('chargeAuditFlow')) === 1
          if (!chargeAuditFlow) {
            for (let i = 0; i < billingChargeState.length; i++) {
              const chargeState = billingChargeState[i]
              if (chargeState.code === ChargeConstants.STATE_REJECT.code) {
                billingChargeState.splice(i, 1)
                break
              }
            }
          }
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeState)
          const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用确认状态
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam('BillingChargeConfirmState', ChargeConstants.CONFIRM_STATES)
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeConfirmState)
          const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 在查询中想要例外的对象列表
      if (defaultSearchConditions.exceptKeys.length > 0) {
        const condition = new AdvancedSearchOption(null, 'charge.UUID', defaultSearchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过付款申请
      if (defaultSearchConditions.hasBillPayment !== -1) {
        const operator = defaultSearchConditions.hasBillPayment === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', defaultSearchConditions.exceptKeys, operator)
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过账单
      if (defaultSearchConditions.hasBilling !== -1) {
        const operator = defaultSearchConditions.hasBilling === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILLING_UUID', defaultSearchConditions.exceptKeys, operator)
        conditions.push(condition.formatObj2Json())
      }
      // 内结
      if (defaultSearchConditions.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }

      // 批量生成账单：查出的全部记录
      this.batchGenerateBillingDialog.conditions = []
      this.batchGenerateBillingDialog.conditions.push(...conditions)
      if (this.showLoading) {
        this.loading = getLoading()
      }
      const requires = [...this.requires]
      if (this.showFba) { requires.push('fba') }
      if (this.hmToFinanceApi) {
        requires.push('hmToFinanceApi')
      }
      const requestBody = {
        conditions,
        requires,
        groups: [],
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        'requestSource': 'Reconciliation'
      }
      requestBody.appendQuery = this.appendQuery
      this.filterParameters = requestBody
      getReconciliationChargeList(requestBody).then(res => {
        let results = res.data.list
        if (results && results.length > 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.rowDataCharge, results, this.appendQuery)
          }
          if (this.updateRows) {
            const { rowsToDisplay } = this.gridOptions.api.getModel()
            rowsToDisplay.forEach(node => {
              if (!node.data) {
                return
              }
              node.setSelected(false)
              const { data } = node
              const newData = results.find(row => row.uuid === data.uuid)
              if (newData) {
                node.setData(newData)
              } else {
                this.gridOptions.api.updateRowData({ remove: [node.data] })
              }
            })
            results.forEach(item => {
              const newData = rowsToDisplay.find(row => row.data && row.data.uuid === item.uuid)
              if (!newData) {
                this.gridOptions.api.updateRowData({ add: [item] })
              }
            })
            this.updateRows = false
          } else {
            this.rowData = results
          }
          this.rowDataCharge = results
          if (defaultSearchConditions.isAr === -1) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_AllB')
          } else if (defaultSearchConditions.isAr === 0) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_DuesB')
          } else if (defaultSearchConditions.isAr === 1) {
            this.totalAmountToCurrency.labelText = this.$t('CargoMsg.Cargo_ReceivableB')
          }
          this.totalAmountToCurrency.dataProvider = results
        } else {
          if (this.appendQuery) return
          this.rowData = []
          this.rowDataCharge = []
          this.totalAmountToCurrency.labelText = ''
          this.totalAmountToCurrency.dataProvider = []
        }
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        this.$nextTick(() => {
          this.afterDataLoaded()
        })
      }).finally(() => {
        if (this.showLoading) {
          this.loading.close()
        }
      })
    },
    // 返回事件
    backReconciliationEvent() {
      this.showLoading = true
      this.currentOptStatus = this.optStatusDefs.normal
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 生成账单(直接点击创建账单按钮或者点击保存对账成功以后，创建账单)
    async createBillingEvent(billing = null) {
      let item = null
      this.createBillWay = 0
      if (billing) {
        item = billing
      } else {
        const chooseRows = getGridSelected(this.gridOptions)
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          return
        }
        const checkCharges = []
        if (this.isJobBillType) {
          for (const job of chooseRows) {
            const charges = job['charges']
            if (charges && charges.length > 0) {
              for (const c of charges) {
                if (c.uuid && c.version) {
                  checkCharges.push({ 'uuid': c.uuid, 'version': c.version })
                }
              }
            }
          }
        } else {
          for (const c of chooseRows) {
            if (c.uuid && c.version) {
              checkCharges.push({ 'uuid': c.uuid, 'version': c.version })
            }
          }
        }
        if (checkCharges && checkCharges.length > 0) {
          const changeCharge = await validateChargeHasUpdate(checkCharges).then((res) => { return res.data })
          if (changeCharge) {
            let modifiedName = ''
            const modifiedBy = changeCharge.modifiedBy
            if (modifiedBy && modifiedBy > 0) {
              const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', Number(modifiedBy))
              if (user) {
                modifiedName = user.chineseName || user.englishName
              }
            }
            this.$message.warning(this.$t('CargoMsg.ChargeHasUpdate', [modifiedName, changeCharge.dateModified]))
            return
          }
        }
        const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
        // CARGO-24198  账单里没有正常显示费用
        let checkBranch = true
        if (!this.isJobBillType) {
          checkBranch = await ReconciliationUtils.checkChargeBranch(chooseRows, false)
        } else {
          checkBranch = await ReconciliationUtils.checkChargeBranch(chooseRows, true)
        }
        if (!checkBranch) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
          return
        }
        // 判断结算代理是否一致
        const sameSettlementAgent = this.isJobBillType ? isSameSettlementAgentByJob2(chooseRows) : isSameSettlementAgent2(chooseRows)
        const sameAccount = this.isJobBillType ? isSameAccountByJob(chooseRows) : isSameAccount(chooseRows)
        if (!sameSettlementAgent && !sameAccount) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CheckCreateBillWay'))
          return
        }
        // 账单创建方式：结算对象不同，结算代理相同，就按结算代理创建，其它的都按 结算对象
        this.createBillWay = (!sameAccount && sameSettlementAgent) ? 1 : 0
        if (this.createBillWay) {
          const sameSettlementAgentId = this.isJobBillType ? getSettlementAgentIdByJob(chooseRows) : getSettlementAgentIdByCharge(chooseRows)
          if (!sameAccount && sameSettlementAgentId === 0) { // 结算对象不一致,结算代理都为0
            this.createBillWay = 0
          }
        }
        if (!this.isJobBillType) {
          item = await ReconciliationUtils.createBillingByCharge(0, chooseRows, defaultSearchConditions.isAr, this.createBillWay)
        } else {
          item = await ReconciliationUtils.createBillingByJob(0, chooseRows, defaultSearchConditions.isAr, this.createBillWay)
        }
        if (!item) {
          return
        }
        await ReconciliationUtils.checkChargesIsSameInvoiceTitleAndSettlementAgent(item, chooseRows, this, true, this.isJobBillType)
        if (this.createBillWay && item['charges'] && item['charges'].length > 0) {
          item['billing'].settlementAgentId = item['charges'][0].chargeSettlementAgentId
        }
      }
      if (item) {
        item['billing'].createBillWay = this.createBillWay
        this.newBilling = item['billing']
        const charges = item['charges']
        const keys = []
        const statusKeys = []
        let flag = false
        let statusFlag = false
        if (charges && charges.length > 0) {
          for (let i = 0; i < charges.length; i++) {
            const uuid = charges[i]['uuid']
            if (keys.indexOf(uuid) < 0) {
              keys.push(uuid)
              if (charges[i]['chargeAmount'] === charges[i]['chargeVerifiedAmount'] && charges[i]['chargeAmount'] !== 0) {
                flag = true
              } else {
                statusFlag = true
                statusKeys.push(uuid)
              }
            }
          }
          this.allCharges = charges
        }
        if (flag) {
          this.$confirm(this.$t('Message.SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            distinguishCancelAndClose: true
          }).then(() => {
            this.checkSplitBill(keys)
          }).catch((action) => {
            if (action === 'close') {
              return
            } else {
              if (statusFlag) {
                this.checkSplitBill(statusKeys)
              } else {
                this.$message.warning(this.$t('Message.AllSelectedFeesWillBeVerifiedPleaseChooseAgain'))
                return
              }
            }
          })
        } else {
          await this.checkSplitBill(keys)
        }
      }
    },
    // 检查账单结算单位有没有开按费用拆分
    async checkSplitBill(keys) {
      this.accounts = []
      if (this.createBillWay && this.allCharges && this.allCharges.length > 0 && keys && keys.length > 0) {
        // 如果按结算代理则需要赋值结算对象
        for (const tempCharge of this.allCharges) {
          if (keys.includes(tempCharge.uuid) && !this.accounts.includes(tempCharge.chargeAccountId)) {
            this.accounts.push(tempCharge.chargeAccountId)
          }
        }
      }
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.newBilling.accountId))
      // 默认走原逻辑
      let normal = true
      if (company) {
        const customerDetail = await new Company(company).getCustomerDetail()
        // 合作伙伴是否开启按费用拆分账单
        if (customerDetail && customerDetail.currencyRequirements > 1) {
          // 确认开启了按费用拆分账单
          normal = false
          // 设置指定币种时 调整账单默认币种
          if (customerDetail.currencyRequirements === 2 && customerDetail.appointCurrency) {
            this.newBilling.currency = customerDetail.appointCurrency
          }
          this.customerDetail = customerDetail
          this.newCharges = keys
          this.currentOptStatus = this.optStatusDefs.newBillDetailView
        }
      }
      if (normal) {
        this.newCharges = keys
        this.currentOptStatus = this.optStatusDefs.billDetailView
      }
    },
    // 开始对账
    startReconciliationBill() {
      if (!this.rowData || this.rowData.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SearchDataForReconciliation'))
        return
      }
      this.currentOptStatus = this.optStatusDefs.checking
      this.grid.isEdit = true
      this.$nextTick(() => {
        this.gridOptions.api.redrawRows()
      })
      // 记录一下原始的列表金额
      this.rowDataBackup = lodash.cloneDeep(this.rowData)
    },
    // 取消对账
    cancelReconciliationBill() {
      this.currentOptStatus = this.optStatusDefs.normal
      this.grid.isEdit = false
      this.showLoading = true
      // 还原数据
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
      /*
      this.rowData = this.rowDataBackup
      this.rowDataBackup = []
      this.totalAmountToCurrency.dataProvider = []
      this.$nextTick(() => {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.refreshSelectedCount()
      })*/
    },
    // 保存对账
    async saveReconciliationEvent() {
      this.loading = getLoading()
      const rowData = this.rowData
      this.grid.isEdit = false
      if (!this.isJobBillType) {
        this.saveCharges = ReconciliationUtils.getNeedSaveChanges(rowData)
      } else if (this.isJobBillType) {
        let saveCharges = []
        for (const job of rowData) {
          const charges = job['charges']
          if (job['dirty'] === true && charges && charges.length > 0) {
            saveCharges = saveCharges.concat(ReconciliationUtils.getNeedSaveChanges(charges))
          }
        }
        this.saveCharges = saveCharges
      }
      if (this.saveCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
        // 保持编辑状态
        this.grid.isEdit = true
        this.loading.close()
        return
      }
      // 按费用对账，使用拆分模式下保存时增加校验
      if (!this.isJobBillType && Number(cache.config.get('DiffChargePattern')) === 2) {
        let hasErrorData = false
        for (const item of this.saveCharges) {
          if (item.uuid) {
            // 现在的含税价
            let newAmount = item.amount
            // 修改之前的含税价
            let sourceAmount = 0.0
            // 1.根据UUID找出原有的费用含税价
            for (const c of this.rowDataBackup) {
              if (c.uuid === item.uuid) {
                sourceAmount = Math.abs(Number(c.chargeAmount))
                break
              }
            }
            let hasDiffCharge = false
            // 2. 找出当前费用拆分出来的新费用, 进行累加计算
            for (const newCharge of this.saveCharges) {
              if (newCharge.diffChargeUuid && newCharge.diffChargeUuid === item.uuid) {
                hasDiffCharge = true
                newAmount = newAmount + newCharge.amount
              }
            }
            newAmount = Math.abs(NumberUtils.ToFixed2(newAmount, 2))
            // 3.判断现在的累计金额是否大于原来的金额,如果时，则有错误数据，要提示客户重新加载数据重新操作
            if (hasDiffCharge && sourceAmount > 0 && newAmount > 0 && newAmount > sourceAmount) {
              hasErrorData = true
              break
            }
          }
        }
        if (hasErrorData) {
          this.$message.warning(this.$t('CargoMsg.Cargo_RefreshData'))
          this.loading.close()
          return
        }
      }
      const dirtyCharges = ReconciliationUtils.filterNeedUpdateCharges(rowData)
      if (dirtyCharges && dirtyCharges.length > 0) {
        await checkCharge(dirtyCharges).then(async res => {
          if (res.data && res.data.length > 0) {
            this.loading.close()
            this.conflictCharges = [...res.data]
            this.showConflictChargeDialog = true
          } else {
            await this.continueSave()
          }
        })
      } else {
        await this.continueSave()
      }
    },
    // 保存第二步骤
    async continueSave(conflicts = []) {
      // 需要保存的费用
      const saveCharges = this.saveCharges
      // 冲突费用
      if (conflicts && conflicts.length > 0) {
        this.loading = getLoading()
        const len = saveCharges.length
        for (let i = len - 1; i >= 0; i--) {
          const charge = saveCharges[i]
          for (let j = 0; j < conflicts.length; j++) {
            const item = conflicts[j]
            if (charge['uuid'] === item['uuid'] || item['uuid'] === charge['diffChargeUuid']) {
              saveCharges.splice(i, 1)
              break
            }
          }
        }
      }
      if (saveCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordToSave'))
        this.loading.close()
        return
      }
      const diffChargePattern = Number(cache.config.get('DiffChargePattern'))
      // 记录开始对账状态下列表数据，用于保存对账成功以后创建账单
      const chargeArray = this.rowData
      saveReconciliation({ charges: saveCharges, diffChargePattern: diffChargePattern, location: this.location, branchId: this.$store.getters.currentOfficeId }).then(async res => {
        const result = res.data
        if (result && result['conflictKeys'] && result['conflictKeys'].length > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_ChargeUpdateFailed', [result['conflictKeys'].length]))
        }
        this.currentOptStatus = this.optStatusDefs.normal
        this.$confirm(this.$t('CargoMsg.Cargo_SaveReconciliationSuccess'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          type: 'success'
        }).then(async() => {
          this.showLoading = false
          if (result && result['newCharges'] && result['newCharges'].length > 0) {
            const newCharges = result['newCharges']
            if (!this.isJobBillType) {
              for (const charge of chargeArray) {
                for (const newCharge of newCharges) {
                  if (charge['chargeUid'] && newCharge['chargeUid'] && charge['chargeUid'] === newCharge['chargeUid']) {
                    charge['uuid'] = newCharge['uuid']
                    break
                  }
                }
              }
            } else if (this.isJobBillType) {
              for (const job of chargeArray) {
                const charges = job['charges']
                if (charges && charges.length > 0) {
                  for (const charge of charges) {
                    for (const newCharge of newCharges) {
                      if (charge['chargeUid'] && newCharge['chargeUid'] && charge['chargeUid'] === newCharge['chargeUid']) {
                        charge['uuid'] = newCharge['uuid']
                        break
                      }
                    }
                  }
                }
              }
            }
          }
          // 对账保存成功以后，根据保存对账时的列表数据确认是否要创建对应的账单
          let billing = null
          const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
          if (!this.isJobBillType) {
            billing = await ReconciliationUtils.createBillingByCharge(1, chargeArray, defaultSearchConditions.isAr)
          } else {
            billing = await ReconciliationUtils.createBillingByJob(1, chargeArray, defaultSearchConditions.isAr)
          }
          if (billing) {
            const billingCharges = billing['charges']
            if (billing['includePaidoff'] === false || (billing['includePaidoff'] === true && billingCharges && billingCharges.length > 0)) {
              await this.$confirm(this.$t('CargoMsg.Cargo_NeedToCreateBillOrNot'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => {
                if (billingCharges.length === 0) {
                  this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToBill'))
                  return
                }
                this.showLoading = false
                this.toAdvQueryList(this.searchConditions.snapshotConditions)
                this.createBillingEvent(billing)
              }).catch(() => {
                this.toAdvQueryList(this.searchConditions.snapshotConditions)
              })
            }
          } else {
            this.toAdvQueryList(this.searchConditions.snapshotConditions)
          }
        })
      }).finally(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
    },
    // 费用冲突弹窗回调函数
    conflictChargeCallBackEventToReconciliation(result) {
      this.showConflictChargeDialog = false
      if (result && result['type'] === true) {
        this.continueSave(result['charges'])
      }
    },
    // 处理差额
    async processDiffAmountEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      let passThrough = true
      let diffCharges = []
      let rowData = this.rowData
      const diffChargePattern = Number(cache.config.get('DiffChargePattern'))
      if (!this.isJobBillType) {
        if (diffChargePattern === 1) {
          diffCharges = await ReconciliationUtils.processChargeDiffAmount(chooseRows, function() {
            passThrough = false
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_CanNotProcessUnsavedNewExpense'), 'warning')
          })
        } else {
          diffCharges = await ReconciliationUtils.splitCharges(chooseRows, function(data) {
            passThrough = false
            if (data === 1) {
              Assert.isTrue(false, this.$t('CargoMsg.Cargo_UnsavedNewExpenseCanTBeSplit'), 'warning')
            } else {
              Assert.isTrue(false, this.$t('CargoMsg.Cargo_TRAYEINR'), 'warning')
            }
          })
          if (this.hmToFinanceApi && passThrough && diffCharges.length > 0) {
            for (const diffCharge of diffCharges) {
              const row = chooseRows.find(p => p.uuid === diffCharge.chargeDiffChargeUuid)
              if (row && row.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
                this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
                return
              }
            }
          }
        }
        if (!passThrough) {
          return
        } else {
          if (!diffCharges || diffCharges.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseDifferentialsToProcess'))
            return
          }
        }
        if (diffCharges && diffCharges.length > 0) {
          rowData = rowData.concat(diffCharges)
        }
      } else if (this.isJobBillType) {
        if (diffChargePattern === 1) {
          diffCharges = await ReconciliationUtils.processJobDiffAmount(chooseRows, function() {
            passThrough = false
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_CanNotProcessUnsavedNewExpense'), 'warning')
          })
        } else {
          diffCharges = await ReconciliationUtils.splitJobCharges(chooseRows, function(data) {
            passThrough = false
            if (data === 1) {
              Assert.isTrue(false, this.$t('CargoMsg.Cargo_UnsavedNewExpenseCanTBeSplit'), 'warning')
            } else {
              Assert.isTrue(false, this.$t('CargoMsg.Cargo_TRAYEINR'), 'warning')
            }
          })
          if (this.hmToFinanceApi && passThrough && diffCharges.length > 0) {
            const jobCharges = []
            for (const row of chooseRows) {
              if (row.charges && row.charges.length > 0) {
                jobCharges.push(...row.charges)
              }
            }
            for (const diffCharge of diffCharges) {
              const charge = jobCharges.find(p => p.uuid === diffCharge.chargeDiffChargeUuid)
              if (charge && charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
                this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
                return
              }
            }
          }
        }
        if (!passThrough) {
          return
        } else {
          if (!diffCharges || diffCharges.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseDifferentialsToProcess'))
            return
          }
        }
        if (diffCharges && diffCharges.length > 0) {
          const newJobs = ReconciliationUtils.splitChargeMergeToJob(diffCharges)
          rowData = rowData.concat(newJobs)
        }
      }
      this.rowData = rowData
    },
    // 批量确认
    batchConfirmEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToConfirm'))
        return
      }
      if (!this.isJobBillType) {
        if (!this.openBatchUpdateConfirmSerialNumber) {
          this.$confirm(this.$t('CargoMsg.Cargo_ACSWASRATBTSWEAC'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            type: 'warning'
          }).then(() => {
            const newSelects = ReconciliationUtils.confirmCharges2(chooseRows)
            this.setNewRow(newSelects)
          }).catch(() => {
          })
        } else {
          this.batchConfirmDialog.confirmSerialNumber = this.$moment(new Date()).format('yyyyMMDD')
          this.batchConfirmDialog.visible = true
        }
      } else if (this.isJobBillType) {
        this.$confirm(this.$t('CargoMsg.Cargo_ACSWASRATBTSWEAC'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          ReconciliationUtils.confirmJobs(chooseRows)
          if (this.gridOptions.api) {
            this.gridOptions.api.updateRowData({ update: chooseRows })
          }
        }).catch(() => {
        })
      }
    },
    // 批量取消确认
    batchCancelConfirmEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToConfirm'))
        return
      }
      if (!this.isJobBillType) {
        this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelConfirmation'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          const newSelects = ReconciliationUtils.cancelConfirmCharges2(chooseRows)
          if (this.openBatchUpdateConfirmSerialNumber) {
            for (const charge of newSelects) {
              charge.chargeConfirmSerialNumber = ''
            }
          }
          this.setNewRow(newSelects)
        }).catch(() => {
        })
      } else if (this.isJobBillType) {
        this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelConfirmation'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          ReconciliationUtils.cancelConfirmJobs(chooseRows)
          if (this.gridOptions.api) {
            this.gridOptions.api.updateRowData({ update: chooseRows })
          }
        }).catch(() => {
        })
      }
    },
    setNewRow(newSelects) {
      const cMap = {}
      for (const item of newSelects) {
        cMap[item.uuid] = item
      }
      const newList = []
      for (const item of this.rowData) {
        if (cMap.hasOwnProperty(item.uuid)) {
          newList.push(cMap[item.uuid])
        } else {
          newList.push(item)
        }
      }
      this.rowData = newList
    },
    // 开票/收票事件
    async makeInvoiceEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecordToInvoice'))
        return
      }
      // 校验分公司是否符合开票要求
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      if (!this.isJobBillType) {
        await this.makeInvoiceByCharge(chooseRows)
      } else {
        await this.makeInvoiceByJob(chooseRows)
      }
    },
    // 按业务开票
    async makeInvoiceByJob(chooseRows) {
      const invoiceJobState = cache.config.get('InvoiceJobState')
      if (invoiceJobState) {
        const invoiceJobStateArray = invoiceJobState.split(',')
        const jobStates = []
        if (invoiceJobStateArray) {
          for (const state of invoiceJobStateArray) {
            jobStates.push(parseInt(state))
          }
          let jobNoStr = ''
          for (let i = 0; i < chooseRows.length; i++) {
            const job = chooseRows[i]
            if (jobStates.indexOf(job['jobJobState']) < 0) {
              jobNoStr = jobNoStr + job['jobJobNo']
              if (i !== chooseRows.length - 1) {
                jobNoStr = jobNoStr + ','
              }
            }
          }
          if (jobNoStr) {
            this.$message.warning(this.$t('CargoMsg.Cargo_BSNMIR'))
            return
          }
        }
      }

      // 不允许“部分已开票 + 部分未开票”一起开票
      const mixJob = this.getInvoiceMixStatusFromJobs(chooseRows)
      if (mixJob.hasInvoiced && mixJob.hasNotInvoiced) {
        this.$message.warning('勾选的业务，存在已开票和未开票，不能一起开票')
        return
      }

      // 已开票：直接打开“发票详情”（避免重复进入开票流程）
      if (await this.tryOpenInvoiceDetailsBySelections(chooseRows, true)) {
        return
      }

      let ar = false
      let ap = false
      const chargeKeys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const job = chooseRows[i]
        const charges = job['charges']
        if (charges && charges.length > 0) {
          for (let j = 0; j < charges.length; j++) {
            const charge = charges[j]
            const key = charge['uuid']
            if (key && chargeKeys.indexOf(key) < 0) {
              chargeKeys.push(key)
            }
            const chargeReceivable = charge['chargeReceivable']
            if (chargeReceivable) {
              // 有应收费用
              ar = true
            } else {
              // 有应付费用
              ap = true
            }
          }
        }
      }
      // 有应收和应付费用 必须开票收票权限都有
      if (ar && ap && (!this.role.createInvoiceFromCharges || !this.role.createInvoiceFromApCharges)) {
        let d = this.$t('CargoMsg.Cargo_CollectInvoice')
        if (this.role.createInvoiceFromCharges) {
          d = this.$t('CargoMsg.Cargo_Invoicing')
        }
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip2', [d]))
        return
      } else if (ar && !this.role.createInvoiceFromCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_CollectInvoice')]))
        return
      } else if (ap && !this.role.createInvoiceFromApCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_Invoicing')]))
        return
      }
      const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
      this.makeInvoiceProperties.makeInvoiceMethod = 2
      this.makeInvoiceProperties.isAr = defaultSearchConditions.isAr === 1
      this.makeInvoiceProperties.isHedge = false
      this.makeInvoiceProperties.isSkipInvoiceFrom = false
      this.makeInvoiceProperties.keys = chargeKeys
      this.makeInvoiceProperties.step = 'step1'
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    // 按费用开票
    async makeInvoiceByCharge(chooseRows) {
      const invoiceChargeConfirmState = cache.config.get('InvoiceChargeConfirmState')
      const invoiceReceiveChargeState = cache.config.get('InvoiceReceiveChargeState')
      const invoicePayChargeState = cache.config.get('InvoicePayChargeState')
      const chargeConfirmStates = []
      const receiveChargeStates = []
      const payChargeStates = []
      if (invoiceChargeConfirmState) {
        const invoiceChargeConfirmStateArray = invoiceChargeConfirmState.split(',')
        for (const state of invoiceChargeConfirmStateArray) {
          chargeConfirmStates.push(parseInt(state))
        }
      }
      if (invoiceReceiveChargeState) {
        const invoiceReceiveChargeStateArray = invoiceReceiveChargeState.split(',')
        for (const state of invoiceReceiveChargeStateArray) {
          receiveChargeStates.push(parseInt(state))
        }
      }
      if (invoicePayChargeState) {
        const invoicePayChargeStateArray = invoicePayChargeState.split(',')
        for (const state of invoicePayChargeStateArray) {
          payChargeStates.push(parseInt(state))
        }
      }
      let errorMessage1 = ''
      let errorMessage2 = ''
      let errorMessage3 = ''
      const chargeKeys = []
      let ar = false
      let ap = false
      let hasInvoiced = false
      let hasNotInvoiced = false
      for (let i = 0; i < chooseRows.length; i++) {
        const charge = chooseRows[i]
        const key = charge['uuid']
        const chargeChargeState = charge['chargeChargeState']
        const chargeConfirmState = charge['chargeConfirmState']
        const chargeReceivable = charge['chargeReceivable']
        const jobNo = charge['jobJobNo']
        if (key && chargeKeys.indexOf(key) < 0) {
          chargeKeys.push(key)
        }
        if (chargeConfirmStates.indexOf(chargeConfirmState) < 0) {
          errorMessage1 = errorMessage1 + jobNo
          if (i !== chooseRows.length - 1) {
            errorMessage1 += ','
          }
        }
        if (chargeReceivable && receiveChargeStates.indexOf(chargeChargeState) < 0) {
          errorMessage2 = errorMessage2 + jobNo
          if (i !== chooseRows.length - 1) {
            errorMessage2 = errorMessage2 + ','
          }
        }
        if (!chargeReceivable && payChargeStates.indexOf(chargeChargeState) < 0) {
          errorMessage3 = errorMessage3 + jobNo
          if (i !== chooseRows.length - 1) {
            errorMessage3 = errorMessage3 + ','
          }
        }
        if (chargeReceivable) {
          // 有应收费用
          ar = true
        } else {
          // 有应付费用
          ap = true
        }

        // 记录开票情况（invoiceUuid 不为空视为已开票）
        if (!StrUtils.isEmpty(charge.invoiceUuid)) {
          hasInvoiced = true
        } else {
          hasNotInvoiced = true
        }
      }

      // 不允许“部分已开票 + 部分未开票”一起开票
      if (hasInvoiced && hasNotInvoiced) {
        this.$message.warning('勾选的费用，存在已开票和未开票，不能一起开票')
        return
      }

      // 全部已开票：直接打开“发票详情”
      if (hasInvoiced && !hasNotInvoiced) {
        if (await this.tryOpenInvoiceDetailsBySelections(chooseRows, false)) {
          return
        }
      }
      // 有应收和应付费用 必须开票收票权限都有
      if (ar && ap && (!this.role.createInvoiceFromCharges || !this.role.createInvoiceFromApCharges)) {
        let d = this.$t('CargoMsg.Cargo_CollectInvoice')
        if (this.role.createInvoiceFromCharges) {
          d = this.$t('CargoMsg.Cargo_Invoicing')
        }
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip2', [d]))
        return
      } else if (ar && !this.role.createInvoiceFromCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_CollectInvoice')]))
        return
      } else if (ap && !this.role.createInvoiceFromApCharges) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_Invoicing')]))
        return
      }

      if (errorMessage1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ECSNMIR'))
        return
      }
      if (errorMessage2) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFTARFSDNMTIR'))
        return
      }
      if (errorMessage3) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFTAPFSDNMTIR'))
        return
      }

      const loading = getLoading()
      try {
        const res = await getNotInvoiceCharges({ keys: chargeKeys })
        if (res && res.data && res.data.length > 0) {
          const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
          this.makeInvoiceProperties.makeInvoiceMethod = 1
          this.makeInvoiceProperties.isAr = defaultSearchConditions.isAr === 1
          this.makeInvoiceProperties.isHedge = false
          this.makeInvoiceProperties.isSkipInvoiceFrom = false
          this.makeInvoiceProperties.keys = chargeKeys
          this.makeInvoiceProperties.step = 'step1'
          await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
          return
        }

        // 全部已开票：用行数据的 invoiceUuid 打开发票详情
        const opened = await this.tryOpenInvoiceDetailsBySelections(chooseRows, false)
        if (!opened) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToInvoice'))
        }
      } finally {
        if (loading && typeof loading.close === 'function') loading.close()
      }
    },
    getInvoiceMixStatusFromJobs(jobs = []) {
      let hasInvoiced = false
      let hasNotInvoiced = false
      for (const job of (jobs || [])) {
        const charges = job ? job.charges : null
        if (!charges || charges.length === 0) {
          // 没有费用明细时，无法判断为“已开票”，按未开票处理，避免误合并开票
          hasNotInvoiced = true
          continue
        }
        for (const c of charges) {
          if (!c) {
            hasNotInvoiced = true
            continue
          }
          if (!StrUtils.isEmpty(c.invoiceUuid)) {
            hasInvoiced = true
          } else {
            hasNotInvoiced = true
          }
        }
      }
      return { hasInvoiced, hasNotInvoiced }
    },
    extractInvoiceUuidsFromCharges(charges = []) {
      const set = new Set()
      let allHas = true
      for (const c of (charges || [])) {
        const raw = c ? c.invoiceUuid : ''
        if (StrUtils.isEmpty(raw)) {
          allHas = false
          continue
        }
        String(raw)
          .split(',')
          .map(s => String(s).trim())
          .filter(s => !StrUtils.isEmpty(s))
          .forEach(s => set.add(s))
      }
      return { invoiceUuids: Array.from(set), allHasInvoiceUuid: allHas }
    },
    extractInvoiceUuidsFromJobs(jobs = []) {
      const set = new Set()
      let allHas = true
      for (const job of (jobs || [])) {
        if (!job) {
          allHas = false
          continue
        }
        // 优先用 job.charges（更精确）；没有 charges 时再兜底用 job.invoiceUuid
        const charges = job.charges
        if (charges && charges.length > 0) {
          for (const c of charges) {
            const raw = c ? c.invoiceUuid : ''
            if (StrUtils.isEmpty(raw)) {
              allHas = false
              continue
            }
            String(raw)
              .split(',')
              .map(s => String(s).trim())
              .filter(s => !StrUtils.isEmpty(s))
              .forEach(s => set.add(s))
          }
          continue
        }

        const jobRaw = job.invoiceUuid
        if (StrUtils.isEmpty(jobRaw)) {
          allHas = false
          continue
        }
        String(jobRaw)
          .split(',')
          .map(s => String(s).trim())
          .filter(s => !StrUtils.isEmpty(s))
          .forEach(s => set.add(s))
      }
      return { invoiceUuids: Array.from(set), allHasInvoiceUuid: allHas }
    },
    async tryOpenInvoiceDetailsBySelections(selections = [], isJob = false) {
      const { invoiceUuids, allHasInvoiceUuid } = isJob
        ? this.extractInvoiceUuidsFromJobs(selections)
        : this.extractInvoiceUuidsFromCharges(selections)

      // 不是“全部已开票”场景，不做跳转（保持原开票逻辑）
      if (!allHasInvoiceUuid) return false

      const keys = Array.from(new Set((invoiceUuids || []).filter(p => !StrUtils.isEmpty(p)))).sort()
      if (keys.length === 0) return false

      // 太多会导致一次性查询/渲染过重；让用户缩小范围
      const MAX_OPEN_INVOICE_COUNT = 50
      if (keys.length > MAX_OPEN_INVOICE_COUNT) {
        this.$message.warning(`匹配到${keys.length}张发票，请缩小勾选范围后再查看`)
        return true
      }

      const invoiceRefRaw = this.$refs ? this.$refs.invoice : null
      const invoiceRef = Array.isArray(invoiceRefRaw) ? invoiceRefRaw[0] : invoiceRefRaw
      if (!invoiceRef || typeof invoiceRef.openInvoiceDetails !== 'function') {
        // 防止“点击无反应”
        this.$message.error('打开发票详情失败')
        return true
      }
      try {
        await invoiceRef.openInvoiceDetails(keys)
      } catch (e) {
        this.$message.error('打开发票详情失败')
      }
      return true
    },
    // 开票成功以后，回调刷新列表数据
    reloadData() {
      this.showLoading = false
      this.updateRows = true
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 费用审核
    auditEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      const chargeIds = []
      const charges = []
      const jobIds = []
      const currentUser = this.$store.getters.userId
      for (const charge of chooseRows) {
        const audit = Number(charge['chargeAuditor'])
        if (charge['chargeChargeState'] === ChargeConstants.STATE_COMMITED.code && audit === Number(currentUser)) {
          chargeIds.push(charge['uuid'])
          charges.push(charge)
          const jobUuid = charge['jobUuid']
          if (jobUuid && jobIds.indexOf(jobUuid) < 0) {
            jobIds.push(jobUuid)
          }
        }
      }

      if (chargeIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToReview'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_SureToBatchReviewTheExpense', [chargeIds.length]), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const params = { chargeIds: chargeIds, jobIds: jobIds, isAudit: true, location: this.location, branchId: this.$store.getters.currentOfficeId }
        putAuditCharges(params).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          this.fetchDataByPage()
        }).catch({})
      }).catch(() => {
      })
    },
    // 取消审核
    auditCancelEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      const chargeIds = []
      const charges = []
      const currentUser = this.$store.getters.userId
      let billinged = false // 已生成账单
      let invoiced = false // 已开票
      let writeOff = false // 已核销
      for (const charge of chooseRows) {
        const audit = Number(charge['chargeAuditor'])
        if (charge['chargeChargeState'] === ChargeConstants.STATE_VERIFIED.code && audit === currentUser) {
          chargeIds.push(charge['uuid'])
          charges.push(charge)
          if (charge.billingUuid) {
            billinged = true
          }
          if (charge.invoiceUuid) {
            invoiced = true
          }
          if (Number(charge.chargeVerifiedAmount) !== 0) {
            writeOff = true
          }
        }
      }

      if (chargeIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoReviewedExpenseToCancel'))
        return
      }
      // CARGO-49982，单票费用，取消审核优化（加提醒弹窗）
      const msg = this.cancelChargesAuditCheckMsg(billinged, invoiced, writeOff)
      this.$confirm(msg ? this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpenseCheck', [msg]) + this.$t('CargoMsg.Cargo_SureToCancelVerification') : this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpense', [chargeIds.length]), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const params = { chargeIds: chargeIds, jobIds: [], isAudit: false, location: this.location, branchId: this.$store.getters.currentOfficeId }
        putAuditCharges(params).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
          this.fetchDataByPage()
        }).catch({})
      }).catch(() => {
      })
    },
    // 费用驳回
    rejectEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      const chargeIds = []
      const currentUser = this.$store.getters.userId
      for (const charge of chooseRows) {
        const audit = Number(charge['chargeAuditor'])
        if (charge['chargeChargeState'] === ChargeConstants.STATE_COMMITED.code && audit === currentUser) {
          chargeIds.push(charge['uuid'])
        }
      }

      if (chargeIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToReject'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpense', [chargeIds.length]), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        rejectCharges(chargeIds, this.location).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.fetchDataByPage()
        }).catch()
      }).catch(() => {
      })
    },
    // 申请付款
    async doBillPayment() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSRTCPA'))
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      if (!this.isJobBillType) {
        await this.doBillPaymentByCharge(chooseRows)
      } else {
        await this.doBillPaymentByJob(chooseRows)
      }
    },
    // 按费用申请付款
    async doBillPaymentByCharge(charges = []) {
      const billPaymentChargeConfirmState = cache.config.get('BillPaymentChargeConfirmState')
      const billPaymentChargeState = cache.config.get('BillPaymentChargeState')
      const keys = []
      let accountId = 0
      let isSameAccount = true
      for (const charge of charges) {
        if (accountId === 0) {
          accountId = charge['chargeAccountId']
        }
        if (accountId !== charge['chargeAccountId']) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
          isSameAccount = false
          return
        }
        if (billPaymentChargeConfirmState) {
          const billPaymentChargeConfirmStateArray = billPaymentChargeConfirmState.split(',')
          const chargeConfirmState = charge['chargeConfirmState']
          if (billPaymentChargeConfirmStateArray && billPaymentChargeConfirmStateArray.length > 0) {
            let count = 0
            for (const item of billPaymentChargeConfirmStateArray) {
              if (Number(item) !== Number(chargeConfirmState)) {
                count++
              }
            }
            if (count === billPaymentChargeConfirmStateArray.length) {
              this.$message.warning(this.$t('CargoMsg.Cargo_ECSNMPAR'))
              return
            }
          }
        }
        if (billPaymentChargeState) {
          const billPaymentChargeStateArray = billPaymentChargeState.split(',')
          const chargeState = charge['chargeChargeState']
          if (billPaymentChargeStateArray && billPaymentChargeStateArray.length > 0) {
            let count = 0
            for (const item of billPaymentChargeStateArray) {
              if (Number(item) !== Number(chargeState)) {
                count++
              }
            }
            if (count === billPaymentChargeStateArray.length) {
              this.$message.warning(this.$t('CargoMsg.Cargo_ESNMPAR'))
              return
            }
          }
        }
        keys.push(charge.uuid)
      }
      // PILL-911 应付账单增加校验，需要在复核后才能付款申请
      if (!(await ClearingUtils.checkCreateBillPaymentByCharges(charges))) return
      if (isSameAccount) {
        await this.showBillPayment(keys)
      }
    },
    // 按业务申请付款
    async doBillPaymentByJob(jobs = []) {
      const billPaymentJobState = cache.config.get('BillPaymentJobState')
      let keys = []
      let accountId = 0
      let isSameAccount = true
      for (const job of jobs) {
        if (accountId === 0) {
          accountId = job['chargeAccountId']
        }
        if (accountId !== job['chargeAccountId']) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
          isSameAccount = false
          return
        }
        if (billPaymentJobState) {
          const billPaymentJobStateArray = billPaymentJobState.split(',')
          const jobState = job['jobJobState']
          if (billPaymentJobStateArray && billPaymentJobStateArray.length > 0) {
            let count = 0
            for (const item of billPaymentJobStateArray) {
              if (Number(item) !== Number(jobState)) {
                count++
              }
            }
            if (count === billPaymentJobStateArray.length) {
              this.$message.warning(this.$t('CargoMsg.Cargo_BSNMPCR'))
              return
            }
          }
        }
        if (job['chargeUuids']) {
          const chargeKeys = job['chargeUuids'].split(',')
          if (chargeKeys && chargeKeys.length > 0) {
            keys = keys.concat(chargeKeys)
          }
        }
      }
      // PILL-911 应付账单增加校验，需要在复核后才能付款申请
      if (!(await ClearingUtils.checkCreateBillPaymentByChargeKeys(keys))) return
      if (isSameAccount) {
        await this.showBillPayment(keys)
      }
    },
    async showBillPayment(chargeUuids = []) {
      const defaultSearchConditions = this.$refs[`${this.billType}ExtCond`].ownConditions
      const charges = await getChargeForBillPayment({ chargeKeys: chargeUuids, ar: defaultSearchConditions.isAr, branchId: this.$store.getters.currentOfficeId }).then((res) => {
        return res.data
      }).finally()
      if (!charges || charges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoChargeForBillPayment'))
        return
      }
      let c1 = 0
      let c2 = 0
      for (const charge of charges) {
        const chargeAmount = isNaN(charge['chargeAmount']) ? 0.0 : charge['chargeAmount']
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge['chargeBranchId'])
        if (charge['chargeReceivable']) {
          c1 += chargeAmount * await RateUtil.getForeignExchangeRateSafely(localCurrency, charge['chargeCurrency'], this.isJobBillType ? new Date() : charge['chargeDateCreated'], charge['chargeBranchId'])
        } else {
          c2 += chargeAmount * await RateUtil.getForeignExchangeRateSafely(localCurrency, charge['chargeCurrency'], this.isJobBillType ? new Date() : charge['chargeDateCreated'], charge['chargeBranchId'])
        }
      }
      if (c1 !== 0 && Math.abs(c1) > Math.abs(c2)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ARAmountCanTExceedAPAmount'))
        return
      }
      this.showBillPaymentDialog = true
      this.$refs.billPayment.initBillPayment(charges)
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 列表checkBox选中变更事件
    selectionChanged() {
      const selections = getGridSelected(this.gridOptions)
      this.selectedCount = selections.length
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed && node.data) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false || this.rowData.length > 0
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    afterDataLoaded() {
      if (this.clearSelectionOnLoad) {
        this.clearSelectionOnLoad = false
        this.selectedCount = 0
        this.totalAmountToCurrency.dataProvider = this.rowData
        if (this.gridOptions.api) {
          this.gridOptions.api.deselectAll()
        }
        return
      }
      this.syncSelectionSummary()
    },
    syncSelectionSummary() {
      const selections = getGridSelected(this.gridOptions)
      this.selectedCount = selections.length
      if (selections.length > 0) {
        this.refreshSelectedCount(0, selections)
        return
      }
      this.selectionChanged()
    },
    refreshSelectedCount(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrency.dataProvider = selections
      } else if (arg === 1) {
        this.totalAmountToCurrency.dataProvider = selections
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.main-content')
        const footer = document.getElementById('footer-wrapper')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 创建账单成功后，点击账单详情界面“返回”按钮回调事件
    cancelBilling() {
      this.currentOptStatus = this.optStatusDefs.normal
      this.showLoading = true
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 销账
    writeoffHandler() {
      this.properties.selectedEntities = getGridSelected(this.gridOptions)
      if (this.properties.selectedEntities.length > 0) {
        if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
          return
        }
      }
      if (this.billType === 'charge') {
        if (this.properties.selectedEntities.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
          return
        }
        this.writeoffByCharge()
      } else {
        if (this.properties.selectedEntities.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
          return
        }
        this.writeoffByJob()
      }
    },
    // 按费用销账
    writeoffByCharge() {
      let accountId = 0
      let isSameAccount = true
      this.properties.writeoffChargeState = String(cache.config.get('WriteoffChargeState'))
      this.properties.writeoffChargeConfirmState = String(cache.config.get('WriteoffChargeConfirmState'))
      const writeoffChargeState = []
      this.properties.writeoffChargeState.split(',').forEach(function(value) {
        writeoffChargeState.push(Number(value))
      })
      const writeoffChargeConfirmState = []
      this.properties.writeoffChargeConfirmState.split(',').forEach(function(value) {
        writeoffChargeConfirmState.push(Number(value))
      })
      for (const item of this.properties.selectedEntities) {
        if (accountId === 0) {
          accountId = item.chargeAccountId
        }
        if (accountId !== item.chargeAccountId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
          isSameAccount = false
          return
        }
        if (writeoffChargeState.length > 0) {
          if (!writeoffChargeState.includes(item.chargeChargeState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ESNMWOR'))
            return
          }
        }
        if (writeoffChargeConfirmState.length > 0) {
          if (!writeoffChargeConfirmState.includes(item.chargeConfirmState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ECSNMWOR'))
            return
          }
        }
        this.properties.accountId = item.chargeAccountId
      }
      if (isSameAccount) {
        this.initEntities()
      }
    },
    // 按业务销账
    writeoffByJob() {
      let accountId = 0
      let isSameAccount = true
      this.properties.writeoffJobState = String(cache.config.get('WriteoffJobState'))
      const writeoffJobState = []
      this.properties.writeoffJobState.split(',').forEach(function(value) {
        writeoffJobState.push(Number(value))
      })
      for (const item of this.properties.selectedEntities) {
        if (accountId === 0) {
          accountId = item.chargeAccountId
        }
        if (accountId !== item.chargeAccountId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
          isSameAccount = false
          return
        }
        if (writeoffJobState.length > 0) {
          if (!writeoffJobState.includes(item.jobJobState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_BSNMWOR'))
            return
          }
        }
        this.properties.accountId = item.chargeAccountId
      }
      if (isSameAccount) {
        this.initEntities()
      }
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      //
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.properties.isAr = this.properties.selectedEntities[0].chargeReceivable
      this.properties.isEntitiesAr = this.properties.isAr
      this.properties.isOversea = (this.defaultSearchConditions.oversea === 1)
      this.properties.writeOffMode = 1
      this.properties.entities = []
      const keys = []
      if (this.billType === 'charge') {
        for (const item of this.properties.selectedEntities) {
          keys.push(item.uuid)
        }
      } else {
        for (const item of this.properties.selectedEntities) {
          item.chargeUuids.split(',').forEach(function(key) {
            keys.push(key)
          })
        }
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': 'charge', 'isOversea': this.properties.isOversea, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToWriteOff'))
        return
      }
      this.properties.accountId = this.properties.entities[0].accountId
      // 按费用销账：组合列表
      if (this.properties.writeOffMode === 1) {
        this.properties.chargeAccountIds = []
        const selectedEntitiesNew = []
        for (const charge of this.properties.entities) {
          if (this.properties.chargeAccountIds.indexOf(charge.accountId) === -1) {
            this.properties.chargeAccountIds.push(charge.accountId)
            selectedEntitiesNew.push({ accountId: charge.accountId })
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      //
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.currencys = []
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking()) {
        this.writeOffDialog.visible = true
      }
    },
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.chargeReceivable) {
          return false
        }
      }
      return true
    },
    // 批量生成账单
    batchGenerateBilling() {
      this.batchGenerateBillingDialog.createMode = 0
      this.batchGenerateBillingDialog.visible = true
    },
    batchGenerateBillingConfirm() {
      const param = {}
      if (this.batchGenerateBillingDialog.createMode === 1) {
        const chooseRows = getGridSelected(this.gridOptions)
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          this.batchGenerateBillingCancel()
          return
        }
        const chargeKeys = []
        for (const charge of chooseRows) {
          chargeKeys.push(charge['uuid'])
        }
        param.chargeKeys = chargeKeys
      } else {
        if (this.batchGenerateBillingDialog.conditions.length === 0) {
          this.$message.warning(this.$t('Message.NoData'))
          this.batchGenerateBillingCancel()
          return
        }
        param.conditions = this.batchGenerateBillingDialog.conditions
      }
      param.branchId = this.$store.getters.currentOfficeId
      param.requestSource = 'Reconciliation'
      param.location = this.location
      console.log('batchGenerateBillingParam', param)
      this.loading = getLoading()
      batchGenerateBilling(param).then(res => {
        console.log('batchGenerateBilling', res.data)
        this.batchGenerateBillingCancel()
        this.$confirm(this.$t('CargoMsg.Cargo_BatchCreateBillSuccess').format(res.data), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'success'
        }).then(() => {
          // 刷新
          this.backReconciliationEvent()
        }).catch(() => {
          this.batchGenerateBillingCancel()
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    batchGenerateBillingCancel() {
      this.batchGenerateBillingDialog.visible = false
    },
    // 提交/取消提交-按钮
    async submitEventHandler(isSubmitCharge = true) {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      if (this.isJobBillType) { // 按业务查询
        let uuids = []
        for (const job of chooseRows) {
          if (job['chargeUuids']) {
            const keys = job['chargeUuids'].split(',')
            if (keys && keys.length > 0) {
              uuids = uuids.concat(keys)
            }
          }
        }
        if (uuids.length > 0) {
          await loadCharges({ chargeKeys: uuids }).then(res => {
            if (res.data && res.data.length > 0) {
              if (!this.checkSubmitChargeState(res.data, isSubmitCharge, this.isJobBillType)) {
                this.$message.warning(this.$t('CargoMsg.Cargo_IncorrectExpenseStatus'))
                return
              }
              const keys = []
              for (const c of res.data) {
                const index = keys.findIndex(e => e === c.uuid)
                if (index < 0) {
                  keys.push(c.uuid)
                }
              }
              this.submitCharge(keys, isSubmitCharge)
            }
          }).catch()
        }
      } else { // 按费用查询
        if (!this.checkSubmitChargeState(chooseRows, isSubmitCharge, this.isJobBillType)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_IncorrectExpenseStatus'))
          return
        }
        const chargeKeys = []
        for (const c of chooseRows) {
          const index = chargeKeys.findIndex(e => e === c.uuid)
          if (index < 0) {
            chargeKeys.push(c.uuid)
          }
        }
        this.submitCharge(chargeKeys, isSubmitCharge)
      }
    },
    // 检查费用状态
    checkSubmitChargeState(charges = [], isSubmitCharge = true, isJob = false) {
      if (charges && charges.length > 0) {
        for (const charge of charges) {
          const chargeState = isJob ? Number(charge.chargeState) : Number(charge.chargeChargeState)
          // 未提交 已驳回允许提交
          if (isSubmitCharge ? (chargeState !== 0 && chargeState !== 3) : chargeState !== 1) {
            return false
          }
        }
      }
      return true
    },
    // 提交费用接口
    submitCharge(chargeKeys, isSubmitCharge) {
      chargeSubmit(chargeKeys, isSubmitCharge ? 1 : 0, this.location).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ExpenseStatusModifiedSuccessfully'))
        this.fetchDataByPage()
      }).catch()
    },
    // 审核/取消审核
    async chargeAuditOrCancelAudit(isAuditCharge = true) {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!this.isJobBillType) { // 按费用查询
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          return
        }
        if (!this.checkAuditChargeState(chooseRows, isAuditCharge, this.isJobBillType)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_IncorrectExpenseStatus'))
          return
        }
        if (isAuditCharge) {
          this.showChargeCheckDialog = true
        } else {
          this.cancelChargesAuditClickHandler()
        }
      } else { // 按业务查询
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.SelectJob'))
          return
        }
        let uuids = []
        for (const job of chooseRows) {
          if (job['chargeUuids']) {
            const keys = job['chargeUuids'].split(',')
            if (keys && keys.length > 0) {
              uuids = uuids.concat(keys)
            }
          }
        }
        if (uuids.length > 0) {
          await loadCharges({ chargeKeys: uuids }).then(res => {
            if (res.data && res.data.length > 0) {
              if (!this.checkAuditChargeState(res.data, isAuditCharge, this.isJobBillType)) {
                this.$message.warning(this.$t('CargoMsg.Cargo_IncorrectExpenseStatus'))
                return
              }
              const keys = []
              for (const c of res.data) {
                const index = keys.findIndex(e => e === c.uuid)
                if (index < 0) {
                  keys.push(c.uuid)
                }
              }
              this.auditChargeHandler(keys, isAuditCharge, res.data)
            }
          }).catch()
        }
      }
    },
    // 取消费用审核
    async cancelChargesAuditClickHandler() {
      const items = getGridSelected(this.gridOptions)
      let billinged = false // 已生成账单
      let invoiced = false // 已开票
      let writeOff = false // 已核销
      const uuidAccountDateMap = {}
      for (const charge of items) {
        if (charge.billingUuid) {
          billinged = true
        }
        if (charge.invoiceUuid) {
          invoiced = true
        }
        if (Number(charge.chargeVerifiedAmount) !== 0) {
          writeOff = true
        }
        charge.chargeState = 2
        // todo 使用job对象model
        charge.accountingDate = null
        uuidAccountDateMap[charge.uuid] = charge.accountingDate
        if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
        uuidAccountDateMap['jobUuid'] = charge.jobUuid
      }
      const msg = this.cancelChargesAuditCheckMsg(billinged, invoiced, writeOff)
      await this.$confirm((msg ? this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpenseCheck', [msg]) : '') + this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', dangerouslyUseHTMLString: true })
      uuidAccountDateMap['location'] = this.location
      this.loading = getLoading()
      batchUpdateChargeState(uuidAccountDateMap, 1).then(res => {
        this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
        this.fetchDataByPage()
      }).finally(() => {
        this.loading.close()
      })
      // todo 标记的操作来源node
      // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'btnChargeAuditCancelClickHandler'))
    },
    /**
     * 费用审核回调
     * @param checkDate
     */
    chargeAuditConfirmCB(accountingDate) {
      const items = getGridSelected(this.gridOptions)
      this.sapChargeList = []
      const openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      const uuidAccountDateMap = {}
      for (const charge of items) {
        charge.chargeState = 2
        //
        if (!charge.accountingDate) {
          charge.accountingDate = accountingDate
        }
        if (openHecConfig) {
          this.sapChargeList.push(charge)
        }
        uuidAccountDateMap[charge.uuid] = charge.accountingDate
        if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
        uuidAccountDateMap['jobUuid'] = charge.jobUuid
      }
      uuidAccountDateMap['location'] = this.location
      this.loading = getLoading()
      batchUpdateChargeState(uuidAccountDateMap, 2).then(res => {
        if (openHecConfig) {
          this.saveChargeAccountDateHandler(ChargeUtils.CHARGE_SH.code, ChargeUtils.CHARGE_PS1.code, true)
        } else {
          this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
          this.fetchDataByPage()
        }
        this.showChargeCheckDialog = false
      }).finally(() => {
        this.loading.close()
      })
      // todo 标记的操作来源node
      // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'chargeAccountDateCallBackHandler'))
    },
    saveChargeAccountDateHandler(oldSapStatus, sapStatus, updateCharge) {
      this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
      const openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      if (this.sapChargeList != null && this.sapChargeList.length > 0 && openHecConfig) {
        // 发送更新sap费用消息
        const chargeKeys = Array.from(this.sapChargeList, p => p.uuid)
        if (openHecConfig) {
          sendHecMessageByCharge(chargeKeys, oldSapStatus, sapStatus, updateCharge, true).then(res => {
            this.sendSapSuccess(res)
          }).catch((err) => {
            this.$message('前端error：回调失败' + err)
          })
        }
      } else {
        this.fetchDataByPage()
      }
    },
    checkAuditChargeState(charges = [], isAuditCharge = true, isJob = false) {
      if (charges && charges.length > 0) {
        for (const charge of charges) {
          const chargeState = isJob ? Number(charge.chargeState) : Number(charge.chargeChargeState)
          if (isAuditCharge ? chargeState !== 1 : chargeState !== 2) {
            return false
          }
        }
      }
      return true
    },
    // 取消审核
    async auditChargeHandler(chargeKeys, isAuditCharge, charges = []) {
      if (!isAuditCharge && charges && charges.length > 0) {
        let billinged = false // 已生成账单
        let invoiced = false // 已开票
        let writeOff = false // 已核销
        for (const charge of charges) {
          if (charge.billingUuid) {
            billinged = true
          }
          if (charge.invoiceUuid) {
            invoiced = true
          }
          if (Number(charge.verifiedAmount) !== 0) {
            writeOff = true
          }
        }
        const msg = this.cancelChargesAuditCheckMsg(billinged, invoiced, writeOff)
        await this.$confirm((msg ? this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpenseCheck', [msg]) : '') + this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', dangerouslyUseHTMLString: true })
      }
      this.loading = getLoading()
      chargeAuditOrCancelAudit(chargeKeys, isAuditCharge ? 2 : 1, this.location).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ExpenseStatusModifiedSuccessfully'))
        this.fetchDataByPage()
      }).catch().finally(
        this.loading.close()
      )
    },
    // 批量修改批次
    batchUpdateConfirmSerialNumber() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      this.showBatchUpdateConfirmSerialNumberDialog = true
    },
    // 批量确认回调函数啊
    batchConfirmHandler() {
      if (this.batchConfirmDialog.confirmSerialNumber && String(this.batchConfirmDialog.confirmSerialNumber).length > 20) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChargeConfirmSerialNumberLengthMore'))
        return
      }
      this.batchConfirmDialog.visible = false
      const chooseRows = getGridSelected(this.gridOptions)
      const newSelects = ReconciliationUtils.confirmCharges2(chooseRows)
      for (const charge of newSelects) {
        charge.chargeConfirmSerialNumber = this.batchConfirmDialog.confirmSerialNumber
      }
      this.setNewRow(newSelects)
    },
    // 批量修改费用确认批次
    batchUpdateConfirmSerialNumberHandler() {
      if (this.confirmSerialNumber && String(this.confirmSerialNumber).length > 20) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChargeConfirmSerialNumberLengthMore'))
        return
      }
      const chooseRows = getGridSelected(this.gridOptions)
      const chargeKeys = []
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      for (const c of chooseRows) {
        const index = chargeKeys.findIndex(e => e === c.uuid)
        if (index < 0) {
          chargeKeys.push(c.uuid)
        }
      }
      this.loading = getLoading()
      batchUpdateConfirmSerialNumber(chargeKeys, this.confirmSerialNumber).then(res => {
        this.showBatchUpdateConfirmSerialNumberDialog = false
        this.confirmSerialNumber = ''
        this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        this.fetchDataByPage()
      }).catch().finally(
        this.loading.close()
      )
    },
    async batchProcessHandler(command) {
      const chooseRows = getGridSelected(this.gridOptions)
      if (command === 'changeAccountId') {
        const chargeUuids = await this.validateBatchProcessCharges(chooseRows, { apOnly: true })
        if (!chargeUuids) {
          return
        }
        this.batchProcessChargeUuids = chargeUuids
        const firstAccountId = Number(chooseRows[0].chargeAccountId || 0)
        const allSameAccount = chooseRows.every(row => Number(row.chargeAccountId || 0) === firstAccountId)
        this.changeAccountIdDialog.isAr = false
        this.changeAccountIdDialog.companyFactorySigns = []
        this.changeAccountIdDialog.showBeforeAfter = true
        this.changeAccountIdDialog.beforeAccountId = allSameAccount ? firstAccountId : 0
        this.changeAccountIdDialog.visible = true
      } else if (command === 'changeInvoiceTitle') {
        const chargeUuids = await this.validateBatchProcessCharges(chooseRows, { requireSameAccount: true })
        if (!chargeUuids) {
          return
        }
        const accountId = Number(chooseRows[0].chargeAccountId || 0)
        const firstTitle = chooseRows[0].chargeInvoiceTitle || ''
        const allSameTitle = chooseRows.every(row => (row.chargeInvoiceTitle || '') === firstTitle)
        this.batchProcessChargeUuids = chargeUuids
        this.changeInvoiceTitleDialog.accountId = accountId
        this.changeInvoiceTitleDialog.defaultInvoiceTitle = ''
        this.changeInvoiceTitleDialog.showBeforeAfter = true
        this.changeInvoiceTitleDialog.beforeInvoiceTitle = allSameTitle ? firstTitle : ''
        this.changeInvoiceTitleDialog.visible = true
      }
    },
    async validateBatchProcessCharges(chooseRows, { apOnly = false, requireSameAccount = false } = {}) {
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToModify'))
        return null
      }
      if (apOnly) {
        for (const row of chooseRows) {
          if (stringToBool(row.chargeReceivable)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ArChargeSettlementCannotModifyDetail', [formatReconciliationChargeLabel(row)]))
            return null
          }
        }
      }
      for (const row of chooseRows) {
        const charge = normalizeReconciliationCharge(row)
        const chargeLabel = formatReconciliationChargeLabel(row)
        if (!isReconciliationChargeShareEnabled(charge)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ChargeSettledCannotModifyDetail', [chargeLabel]))
          return null
        }
        if (!checkRoleEdit(charge, this.chargeEditPrivilege)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanNotEditChargeDetail', [chargeLabel]))
          return null
        }
      }
      for (const row of chooseRows) {
        const branchEditable = await ReconciliationUtils.isChargeRowBranchEditable(row)
        if (!branchEditable) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranchDetail', [formatReconciliationChargeLabel(row)]))
          return null
        }
      }
      if (requireSameAccount && !isSameAccount(chooseRows)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyMustBeConsistent'))
        return null
      }
      const chargeUuids = []
      for (const row of chooseRows) {
        if (row.uuid && chargeUuids.indexOf(row.uuid) < 0) {
          chargeUuids.push(row.uuid)
        }
      }
      return chargeUuids.length > 0 ? chargeUuids : null
    },
    onBatchChangeAccountIdConfirm({ accountId }) {
      if (!accountId) {
        return
      }
      this.loading = getLoading()
      batchUpdateChargeAccountId({
        chargeUuids: this.batchProcessChargeUuids,
        accountId,
        location: this.location
      }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        this.fetchDataByPage()
      }).catch().finally(() => {
        this.loading.close()
      })
    },
    onBatchChangeInvoiceTitleConfirm({ invoiceTitle }) {
      if (!invoiceTitle) {
        return
      }
      this.loading = getLoading()
      batchUpdateChargeInvoiceTitle({
        chargeUuids: this.batchProcessChargeUuids,
        invoiceTitle,
        location: this.location
      }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        this.fetchDataByPage()
      }).catch().finally(() => {
        this.loading.close()
      })
    },
    getDepartmentsByOfficeUuid(branchId) {
      const officeIdForDepartmentMap = this.officeIdForDepartmentMap
      if (!officeIdForDepartmentMap.has(branchId)) {
        const officeArr = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office_All, (item) => item.officeId === branchId)
        const officeUuid = officeArr.length ? officeArr[0].uuid : ''
        const results = []
        if (officeUuid) {
          let departments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department_All, (item) => {
            return item.officeUuid === officeUuid && item.jobNoPrefix && item.code
          })
          if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
            const officeUuids = JobUtils.getChildOfficeUUIDs(officeUuid)
            departments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department_All, (item) => {
              return officeUuids.includes(item.officeUuid) && item.jobNoPrefix && item.code
            })
          }
          for (const item of departments) {
            results.push({ code: item.jobNoPrefix, jobNoPrefix: item.jobNoPrefix, chineseName: item.chineseName, englishName: item.englishName })
          }
        }
        officeIdForDepartmentMap.set(branchId, results)
      }
      return officeIdForDepartmentMap.get(Number(branchId)) || []
    },
    batchUploadFileHandler() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
        return
      }
      const loading = getLoading4Cxt(this)
      let checkCharges = []
      if (this.isJobBillType) {
        for (const job of chooseRows) {
          const charges = job['charges']
          const list = charges.map(row => row.uuid)
          checkCharges = [...list, ...checkCharges]
        }
      } else {
        checkCharges = chooseRows.map(row => row.uuid)
      }
      const data = {
        keys: checkCharges
      }
      queryJobByChargeKeysFunc(data).then(res => {
        if (!res.data || !res.data.redisKey) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
          return
        }
        if (res.data.multipleLob) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload2'))
          return
        }
        this.showCloudFile(res.data)
      }).finally(e => {
        loading.close()
      })
    },
    showCloudFile(data) {
      this.cloudFile.redisKey = data.redisKey
      this.cloudFile.lob = data.lob
      this.cloudFile.num = data.num
      this.cloudFile.visible = true
    },
    toManualSyncHM() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      const chargeKeys = []
      for (const row of rows) {
        if (row.chargeSyncExternalStatus !== ChargeConstants.HM_YONGYOU_NOT_SYNC.code) {
          this.$message.warning(this.$t('Clearing.SelectNotSyncManualPush'))
          return
        }
        if (row.chargeChargeState === ChargeConstants.STATE_VERIFIED.code) {
          chargeKeys.push(row.uuid)
        }
      }
      if (chargeKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSynchronizedFees'))
        return
      }
      const loading = getLoading4Cxt(this)
      doHmSyncZgChargeToYongYou(chargeKeys).then(res => {
        loading.close()
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        this.fetchDataByPage()
      }).catch(() => {
        loading.close()
      })
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 取消费用审核提醒:已生成账单、已开票、已核销
    cancelChargesAuditCheckMsg(billinged = false, invoiced = false, writeOff = false) {
      let msg = ''
      if (billinged) {
        msg = '【' + this.$t('CargoMsg.Cargo_Billinged') + '】'
      }
      if (invoiced) {
        msg += (msg ? '、' : '') + '【' + this.$t('CargoMsg.Cargo_Invoiced') + '】'
      }
      if (writeOff) {
        msg += (msg ? '、' : '') + '【' + this.$t('CargoMsg.Cargo_WriteOffed') + '】'
      }
      return msg
    },
    cancelReviewRemarks() {
      this.currentOptStatus = this.optStatusDefs.normal
      this.reviewEditDialog.visible = false
    },
    reviewRemarks() {
      this.currentOptStatus = this.optStatusDefs.reviewRemarks
      this.reviewEditDialog.visible = true
    },
    financialRemarks() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      this.financialRemarksFormDialog.visible = true
      this.financialRemarksFormDialog.remarks = ''
    },
    cancelFinancialRemarks() {
      this.financialRemarksFormDialog.visible = false
      this.financialRemarksFormDialog.remarks = ''
    },
    async saveFinancialRemarks() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      if (!this.financialRemarksFormDialog.remarks.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_FinancialRemarks'))
        return
      }

      this.loading = getLoading()
      const saveCharges = []
      for (let i = 0; i < chooseRows.length; i++) {
        const charge = chooseRows[i]
        if (this.isJobBillType && charge.chargeUuids) {
          const chargeUuids = charge['chargeUuids']
            .split(',')
            .map(uuid => uuid.trim())
            .filter(uuid => uuid)
          if (chargeUuids.length > 0) {
            chargeUuids.forEach(uuid => {
              const update = {}
              update['uuid'] = uuid
              // 将新备注追加到原有财务备注后面
              const originalRemarks = charge['financialRemarks'] || ''
              const newRemarks = originalRemarks
                ? `${originalRemarks}；${this.financialRemarksFormDialog.remarks}`
                : this.financialRemarksFormDialog.remarks
              update['remarks'] = newRemarks
              saveCharges.push(update)
            })
          }
        } else {
          const update = {}
          update['uuid'] = charge['uuid']
          // 将新备注追加到原有财务备注后面
          const originalRemarks = charge['financialRemarks'] || ''
          const newRemarks = originalRemarks
            ? `${originalRemarks}；${this.financialRemarksFormDialog.remarks}`
            : this.financialRemarksFormDialog.remarks
          update['remarks'] = newRemarks
          saveCharges.push(update)
        }
      }
      await updateFinancialRemarks(saveCharges).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).catch().finally(
        this.loading.close()
      )
      this.financialRemarksFormDialog.visible = false
      this.financialRemarksFormDialog.remarks = ''
      // 刷新数据
      this.fetchDataByPage()
    },
    confirmationLetterRemarks() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      this.confirmationLetterRemarksFormDialog.visible = true
      this.confirmationLetterRemarksFormDialog.remarks = ''
    },
    cancelConfirmationLetterRemarks() {
      this.confirmationLetterRemarksFormDialog.visible = false
      this.confirmationLetterRemarksFormDialog.remarks = ''
    },
    async saveConfirmationLetterRemarks() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }

      if (!this.confirmationLetterRemarksFormDialog.remarks.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Billing.InquiryLetterRemark'))
        return
      }

      this.loading = getLoading()
      const saveCharges = []
      for (let i = 0; i < chooseRows.length; i++) {
        const charge = chooseRows[i]
        if (this.isJobBillType && charge.chargeUuids) {
          const chargeUuids = charge['chargeUuids']
            .split(',')
            .map(uuid => uuid.trim())
            .filter(uuid => uuid)
          if (chargeUuids.length > 0) {
            chargeUuids.forEach(uuid => {
              const update = {}
              update['uuid'] = uuid
              update['remarks'] = this.confirmationLetterRemarksFormDialog.remarks
              saveCharges.push(update)
            })
          }
        } else {
          const update = {}
          update['uuid'] = charge['uuid']
          // 将新备注覆盖原备注
          update['remarks'] = this.confirmationLetterRemarksFormDialog.remarks
          saveCharges.push(update)
        }
      }

      await updateConfirmationLetterRemarks(saveCharges).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).catch().finally(
        this.loading.close()
      )
      this.confirmationLetterRemarksFormDialog.visible = false
      this.confirmationLetterRemarksFormDialog.remarks = ''
      // 刷新数据
      this.fetchDataByPage()
    },
    async saveReviewRemarks() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      this.loading = getLoading()
      const saveCharges = []
      for (let i = 0; i < chooseRows.length; i++) {
        const charge = chooseRows[i]
        const update = {}
        update['uuid'] = charge['uuid']
        update['reviewRemarks'] = charge['reviewRemarks']
        saveCharges.push(update)
      }
      await updateChargeReviewRemark(saveCharges).then(res => {
      }).catch().finally(
        this.loading.close()
      )
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      this.loading = getLoading()
      const useHqSet = true
      const res = await getInstructions({
        pageType: UICustomConstants.BILLING_NATIVE_RECONCILIATION,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet
      }).finally(
        () => {
          this.loading.close()
        }
      )
      const list = []
      for (const item of res.data) {
        if (item.instructionCode === 'reconciliationCharge' && item.platformInstructionRuleCode === 'reviewRemarks') {
          this.operateReviewRemarkDialog.visible = true
          this.reviewTitle = this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
        } else if (item.instructionCode === 'financialRemarksChargeJob' && item.platformInstructionRuleCode === 'financialRemarks') {
          this.financialRemarksDialog.visible = true
          this.financialRemarksTitle = this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
        } else if (item.instructionCode === 'confirmationLetterChargeJob' && item.platformInstructionRuleCode === 'confirmationLetterRemarks') {
          this.confirmationLetterRemarksDialog.visible = true
          this.confirmationLetterRemarksTitle = this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
        } else {
          list.push(item)
        }
      }
      this.instructioinBtns = list
    },
    showInvoicePoolDialog() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      this.invoicePoolDialog.sellerTaxNameDefaultValue = this.isJobBillType ? chooseRows[0].invoiceTitle : chooseRows[0].chargeInvoiceTitle
      this.invoicePoolDialog.selectedEntities = chooseRows
      this.invoicePoolDialog.operation = 'collection'
      this.invoicePoolDialog.source = 'reconciliation'
      this.invoicePoolDialog.makeInvoiceMethod = this.billType === 'charge' ? 1 : 2
      this.invoicePoolDialog.visible = true
    }
  }
}
// eslint-disable-next-line no-extend-native
String.prototype.format = function() {
  if (arguments.length === 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) { s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i]) }
  return s
}
</script>

<style lang="scss">
#footer-wrapper {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
</style>
